function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg0_svg__a",
  d: "M0 595.4h323.2V1854H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "bg0_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg0_svg__a",
  overflow: "visible"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg0_svg__b)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__c",
  gradientUnits: "userSpaceOnUse",
  x1: 118.019,
  y1: 756.341,
  x2: 118.019,
  y2: 2658.041,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M276 869c0 119.7-150.4 183.9-84.3 357.9C237 1346.1 77.8 1487.3-2.2 1657.2c-123.9 263.1 100.5 446.8 58.6 718.4-38.9 251.7 219.4 285 219.4 395.1",
  fill: "none",
  stroke: "url(#bg0_svg__c)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__d",
  gradientUnits: "userSpaceOnUse",
  x1: 112.386,
  y1: 756.341,
  x2: 112.386,
  y2: 2658.141,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M266.4 868.9c0 115.8-145.7 182.4-82.1 357.5 43.5 119.4-110.9 260.8-189 430.5-120.8 262.5 97 447.7 57.2 717.2-37 248.9 213.6 285.9 213.6 396.6",
  fill: "none",
  stroke: "url(#bg0_svg__d)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__e",
  gradientUnits: "userSpaceOnUse",
  x1: 106.852,
  y1: 756.441,
  x2: 106.852,
  y2: 2658.141,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M256.9 868.9c0 111.9-140.9 180.9-80 357 41.8 119.6-107.9 261.3-184 430.6-117.7 261.9 93.5 448.7 55.9 716-35.1 246 207.8 286.8 207.8 398.1",
  fill: "none",
  stroke: "url(#bg0_svg__e)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__f",
  gradientUnits: "userSpaceOnUse",
  x1: 101.247,
  y1: 756.341,
  x2: 101.247,
  y2: 2658.141,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M247.3 868.9c0 108.1-136.5 179.5-77.8 356.6 39.8 119.8-104.9 261.8-179 430.7-114.7 261.3 90 449.6 54.5 714.9-33.2 243.2 202 287.6 202 399.6",
  fill: "none",
  stroke: "url(#bg0_svg__f)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__g",
  gradientUnits: "userSpaceOnUse",
  x1: 95.64,
  y1: 756.341,
  x2: 95.64,
  y2: 2658.141,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M237.7 868.9c0 104.2-131.9 178.1-75.6 356.1 38 120.1-102 262.2-174.1 430.9-111.5 260.7 86.6 450.5 53.3 713.7-31.4 240.3 196.3 288.5 196.3 401.1",
  fill: "none",
  stroke: "url(#bg0_svg__g)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__h",
  gradientUnits: "userSpaceOnUse",
  x1: 90.163,
  y1: 756.241,
  x2: 90.163,
  y2: 2658.141,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M228.2 868.9c0 100.4-127.2 176.6-73.4 355.7 36.2 120.3-99 262.7-169.1 431.1-108.5 260.1 83.6 451.5 51.8 712.5-29 237.5 190.5 289.4 190.5 402.6",
  fill: "none",
  stroke: "url(#bg0_svg__h)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__i",
  gradientUnits: "userSpaceOnUse",
  x1: 84.57,
  y1: 756.341,
  x2: 84.57,
  y2: 2658.241,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M218.6 868.8c0 96.5-122.6 175.1-71.2 355.2 34.3 120.5-96 263.2-164.1 431.2-105.5 259.5 80.3 452.4 50.5 711.4-27 234.7 184.7 290.2 184.7 404.1",
  fill: "none",
  stroke: "url(#bg0_svg__i)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__j",
  gradientUnits: "userSpaceOnUse",
  x1: 79.04,
  y1: 756.241,
  x2: 79.04,
  y2: 2658.241,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M209.1 868.8c0 92.6-117.9 173.6-69 354.8 32.6 120.6-93 263.7-159.2 431.4-102.4 258.9 76.9 453.3 49.1 710.2-25 231.8 178.9 291.1 178.9 405.6",
  fill: "none",
  stroke: "url(#bg0_svg__j)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__k",
  gradientUnits: "userSpaceOnUse",
  x1: 73.41,
  y1: 756.341,
  x2: 73.41,
  y2: 2658.241,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M199.5 868.8c0 88.8-113.2 172.2-66.9 354.3 30.8 120.8-90 264.1-154.2 431.5-99.3 258.3 73.5 454.2 47.8 709-23.1 229 173.2 292 173.2 407.1",
  fill: "none",
  stroke: "url(#bg0_svg__k)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__l",
  gradientUnits: "userSpaceOnUse",
  x1: 67.859,
  y1: 756.241,
  x2: 67.859,
  y2: 2658.241,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M190 868.8c0 84.9-108.5 170.7-64.7 353.9 29 121-87 264.6-149.3 431.7-96.3 257.7 70.1 455.1 46.4 707.9-21.2 226.1 167.4 292.8 167.4 408.5",
  fill: "none",
  stroke: "url(#bg0_svg__l)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__m",
  gradientUnits: "userSpaceOnUse",
  x1: 62.278,
  y1: 756.341,
  x2: 62.278,
  y2: 2658.241,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M180.4 868.8c0 81.1-103.8 169.2-62.5 353.4 27.2 121.2-84 265.1-144.3 431.8-93.2 257.1 66.7 456 45.1 706.7-19.2 223.2 161.6 293.7 161.6 410",
  fill: "none",
  stroke: "url(#bg0_svg__m)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__n",
  gradientUnits: "userSpaceOnUse",
  x1: 56.69,
  y1: 756.241,
  x2: 56.69,
  y2: 2658.241,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M170.8 868.8c0 77.2-99.1 167.7-60.3 353 25.4 121.4-81 265.5-139.3 432-90.1 256.5 63.2 457 43.7 705.5-17.3 220.4 155.8 294.6 155.8 411.5",
  fill: "none",
  stroke: "url(#bg0_svg__n)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__o",
  gradientUnits: "userSpaceOnUse",
  x1: 51.137,
  y1: 756.441,
  x2: 51.137,
  y2: 2658.341,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M161.3 868.7c0 73.3-94.4 166.2-58.1 352.5 23.7 121.6-78 266-134.4 432.1-87.1 255.9 59.8 457.9 42.4 704.3-15.4 217.5 150 295.4 150 413",
  fill: "none",
  stroke: "url(#bg0_svg__o)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__p",
  gradientUnits: "userSpaceOnUse",
  x1: 45.553,
  y1: 756.341,
  x2: 45.553,
  y2: 2658.341,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M151.7 868.7c0 69.5-89.7 164.7-55.9 352.1 21.9 121.7-75 266.5-129.4 432.2-84 255.3 56.4 458.8 41 703.2-13.5 214.7 144.3 296.3 144.3 414.5",
  fill: "none",
  stroke: "url(#bg0_svg__p)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__q",
  gradientUnits: "userSpaceOnUse",
  x1: 40.013,
  y1: 756.341,
  x2: 40.013,
  y2: 2658.341,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M142.2 868.7c0 65.6-84.9 163.2-53.8 351.6 20.2 121.9-72 266.9-124.4 432.4-80.9 254.7 52.9 459.7 39.7 702-11.6 211.8 138.5 297.2 138.5 416",
  fill: "none",
  stroke: "url(#bg0_svg__q)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__r",
  gradientUnits: "userSpaceOnUse",
  x1: 34.407,
  y1: 756.341,
  x2: 34.407,
  y2: 2658.341,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M132.6 868.7c0 61.8-80.2 161.7-51.6 351.1 18.5 122.1-69 267.4-119.4 432.6-77.9 254.1 49.5 460.6 38.3 700.8-9.7 209 132.7 298 132.7 417.5",
  fill: "none",
  stroke: "url(#bg0_svg__r)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__s",
  gradientUnits: "userSpaceOnUse",
  x1: 28.864,
  y1: 756.241,
  x2: 28.864,
  y2: 2658.341,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M123.1 868.7c0 57.9-75.4 160.1-49.4 350.7 16.6 122.2-66.1 267.8-114.5 432.7-74.8 253.5 46 461.5 37 699.7-7.8 206.1 126.9 298.9 126.9 419",
  fill: "none",
  stroke: "url(#bg0_svg__s)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__t",
  gradientUnits: "userSpaceOnUse",
  x1: 23.32,
  y1: 756.341,
  x2: 23.32,
  y2: 2658.341,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M113.5 868.7c0 54-70.6 158.6-47.2 350.2 15 122.4-63.1 268.4-109.5 432.8-71.7 252.9 42.5 462.4 35.6 698.5-5.9 203.2 121.2 299.8 121.2 420.5",
  fill: "none",
  stroke: "url(#bg0_svg__t)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__u",
  gradientUnits: "userSpaceOnUse",
  x1: 17.653,
  y1: 756.441,
  x2: 17.653,
  y2: 2658.441,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M103.9 868.6c0 50.2-65.9 157.1-45 349.8 13.3 122.6-60.1 268.8-104.6 433-68.7 252.3 39 463.3 34.3 697.3-4.1 200.4 115.4 300.6 115.4 421.9",
  fill: "none",
  stroke: "url(#bg0_svg__u)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__v",
  gradientUnits: "userSpaceOnUse",
  x1: 12.155,
  y1: 756.441,
  x2: 12.155,
  y2: 2658.441,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M94.4 868.6c0 46.3-61.1 155.6-42.8 349.3C63.1 1340.7-5.5 1487.2-48 1651c-65.6 251.8 35.5 464.2 32.9 696.2-2.2 197.5 109.6 301.5 109.6 423.4",
  fill: "none",
  stroke: "url(#bg0_svg__v)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__w",
  gradientUnits: "userSpaceOnUse",
  x1: 6.505,
  y1: 756.341,
  x2: 6.505,
  y2: 2658.441,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M84.8 868.6c0 42.5-56.2 154.1-40.7 348.9 9.9 122.9-54 269.7-94.6 433.3-62.5 251.2 32 465.1 31.6 695-.4 194.6 103.8 302.4 103.8 424.9",
  fill: "none",
  stroke: "url(#bg0_svg__w)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__x",
  gradientUnits: "userSpaceOnUse",
  x1: 0.881,
  y1: 756.341,
  x2: 0.881,
  y2: 2658.441,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M75.3 868.6c0 38.6-51.4 152.6-38.5 348.4 8.1 123.1-51.1 270.2-89.7 433.4-59.5 250.6 28.5 466 30.2 693.9 1.5 191.8 98 303.2 98 426.4",
  fill: "none",
  stroke: "url(#bg0_svg__x)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__y",
  gradientUnits: "userSpaceOnUse",
  x1: -4.625,
  y1: 756.341,
  x2: -4.625,
  y2: 2658.441,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M65.7 868.6c0 34.7-46.6 151.1-36.3 348 6.4 123.2-48.1 270.6-84.7 433.5-56.4 250 25 466.9 28.9 692.7 3.3 188.9 92.3 304.1 92.3 427.9",
  fill: "none",
  stroke: "url(#bg0_svg__y)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__z",
  gradientUnits: "userSpaceOnUse",
  x1: -10.243,
  y1: 756.341,
  x2: -10.243,
  y2: 2658.541,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.1 868.5c0 30.9-41.7 149.6-34.1 347.5 4.8 123.5-45.1 271.2-79.7 433.8-53.3 249.4 21.4 467.8 27.5 691.5 5.1 186.1 86.5 305 86.5 429.4",
  fill: "none",
  stroke: "url(#bg0_svg__z)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__A",
  gradientUnits: "userSpaceOnUse",
  x1: -15.837,
  y1: 756.341,
  x2: -15.837,
  y2: 2658.541,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M46.6 868.5c0 27-36.9 148-31.9 347.1 3.1 123.6-42.1 271.6-74.8 433.9-50.3 248.8 17.8 468.7 26.2 690.3 6.9 183.2 80.7 305.8 80.7 430.9",
  fill: "none",
  stroke: "url(#bg0_svg__A)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__B",
  gradientUnits: "userSpaceOnUse",
  x1: -21.487,
  y1: 756.341,
  x2: -21.487,
  y2: 2658.541,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37 868.5c0 23.2-32 146.5-29.8 346.6 1.4 123.8-39.1 272.1-69.8 434-47.1 248.2 14.3 469.7 24.9 689.2 8.7 180.3 74.9 306.7 74.9 432.4",
  fill: "none",
  stroke: "url(#bg0_svg__B)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__C",
  gradientUnits: "userSpaceOnUse",
  x1: -27.096,
  y1: 756.241,
  x2: -27.096,
  y2: 2658.541,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.5 868.5c0 19.3-27.1 145-27.6 346.2-.3 124-36.1 272.6-64.9 434.2-44.1 247.6 10.7 470.5 23.5 688 10.5 177.5 69.2 307.6 69.2 433.9",
  fill: "none",
  stroke: "url(#bg0_svg__C)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__D",
  gradientUnits: "userSpaceOnUse",
  x1: -32.775,
  y1: 756.341,
  x2: -32.775,
  y2: 2658.541,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.9 868.5c0 15.4-22.3 143.5-25.4 345.7-1.9 124.1-33.2 273-59.9 434.3-41.1 247 7 471.4 22.1 686.8 12.2 174.6 63.4 308.4 63.4 435.4",
  fill: "none",
  stroke: "url(#bg0_svg__D)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__E",
  gradientUnits: "userSpaceOnUse",
  x1: -38.386,
  y1: 756.341,
  x2: -38.386,
  y2: 2658.541,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.4 868.5c0 11.6-17.4 142-23.2 345.3-3.6 124.2-30.2 273.4-55 434.4-38 246.4 3.4 472.3 20.8 685.7 14 171.8 57.6 309.3 57.6 436.8",
  fill: "none",
  stroke: "url(#bg0_svg__E)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__F",
  gradientUnits: "userSpaceOnUse",
  x1: -44.105,
  y1: 756.441,
  x2: -44.105,
  y2: 2658.641,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-1.2 868.4c0 7.7-12.1 140.6-21 344.8-5 124.5-27.2 274-50 434.6-34.9 245.8-.6 473.3 19.4 684.5 15.4 169 51.8 310.2 51.8 438.3",
  fill: "none",
  stroke: "url(#bg0_svg__F)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__G",
  gradientUnits: "userSpaceOnUse",
  x1: -49.771,
  y1: 756.341,
  x2: -49.771,
  y2: 2658.641,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-10.8 868.4c0 3.9-7.4 139.1-18.8 344.4-6.8 124.7-24.2 274.5-45 434.8-31.9 245.2-4.1 474.2 18.1 683.3 17.3 166.1 46 311 46 439.8",
  fill: "none",
  stroke: "url(#bg0_svg__G)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__H",
  gradientUnits: "userSpaceOnUse",
  x1: -55.443,
  y1: 756.341,
  x2: -55.443,
  y2: 2658.648,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.563,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-20.3 868.4S-27 1222.9-77 1647.2c-51.5 437.4 57 830 57 1123.5",
  fill: "none",
  stroke: "url(#bg0_svg__H)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg0_svg__I",
  d: "M0-3.5h323.2V1826H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bg0_svg__J"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg0_svg__I",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg0_svg__J)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__K",
  gradientUnits: "userSpaceOnUse",
  x1: -180.976,
  y1: 3062.99,
  x2: 276.171,
  y2: 3062.99,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-156.5 59C-280.3 322.1 116.3 255.9 74.4 527.5 35.6 779.2 275.8 759.2 275.8 869.3",
  fill: "none",
  stroke: "url(#bg0_svg__K)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__L",
  gradientUnits: "userSpaceOnUse",
  x1: -182.811,
  y1: 3063.188,
  x2: 266.571,
  y2: 3063.188,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-158.9 58.6C-279.7 321.7 106.8 260.5 68.5 527.2 32.4 773.4 266.2 757.1 266.2 869.3",
  fill: "none",
  stroke: "url(#bg0_svg__L)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__M",
  gradientUnits: "userSpaceOnUse",
  x1: -184.644,
  y1: 3063.386,
  x2: 257.071,
  y2: 3063.386,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-161.3 58.3C-279.2 321.3 98 265.2 62.5 526.9 30 767.7 256.7 755.1 256.7 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__M)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__N",
  gradientUnits: "userSpaceOnUse",
  x1: -186.465,
  y1: 3063.534,
  x2: 247.571,
  y2: 3063.534,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-163.7 58C-278.6 321 88.8 269.9 56.6 526.7 27.2 762 247.2 753 247.2 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__N)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__O",
  gradientUnits: "userSpaceOnUse",
  x1: -188.286,
  y1: 3063.683,
  x2: 237.971,
  y2: 3063.683,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-166.1 57.7C-278 320.6 79.6 274.5 50.7 526.4 24.3 756.2 237.6 751 237.6 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__O)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__P",
  gradientUnits: "userSpaceOnUse",
  x1: -190.107,
  y1: 3063.881,
  x2: 228.471,
  y2: 3063.881,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-168.5 57.3c-108.9 263 238.9 221.8 213.3 468.8-23.3 224.3 183.3 222.8 183.3 343.1",
  fill: "none",
  stroke: "url(#bg0_svg__P)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__Q",
  gradientUnits: "userSpaceOnUse",
  x1: -191.929,
  y1: 3064.029,
  x2: 218.871,
  y2: 3064.029,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-170.9 57C-276.8 319.9 61.2 283.7 38.8 525.8c-20.2 218.8 179.7 221 179.7 343.4",
  fill: "none",
  stroke: "url(#bg0_svg__Q)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__R",
  gradientUnits: "userSpaceOnUse",
  x1: -193.755,
  y1: 3064.177,
  x2: 209.371,
  y2: 3064.177,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-173.3 56.7C-276.2 319.6 51.9 288.2 32.9 525.5 15.8 738.9 209 744.8 209 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__R)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__S",
  gradientUnits: "userSpaceOnUse",
  x1: -195.64,
  y1: 3064.275,
  x2: 199.871,
  y2: 3064.275,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-175.8 56.4C-275.6 319.2 42.7 292.8 27 525.3c-14.1 207.8 172.5 217.5 172.5 344",
  fill: "none",
  stroke: "url(#bg0_svg__S)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__T",
  gradientUnits: "userSpaceOnUse",
  x1: -197.462,
  y1: 3064.473,
  x2: 190.271,
  y2: 3064.473,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-178.2 56.1C-275 318.9 33.5 297.4 21 525 10 727.3 189.9 740.7 189.9 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__T)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__U",
  gradientUnits: "userSpaceOnUse",
  x1: -199.287,
  y1: 3064.671,
  x2: 180.771,
  y2: 3064.671,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-180.6 55.7c-93.8 262.8 204.8 246.2 195.7 469-8 196.7 165.3 214 165.3 344.5",
  fill: "none",
  stroke: "url(#bg0_svg__U)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__V",
  gradientUnits: "userSpaceOnUse",
  x1: -201.113,
  y1: 3064.82,
  x2: 171.271,
  y2: 3064.82,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-183 55.4c-90.8 262.8 197.9 251.1 192.2 469-5 191.2 161.7 212.2 161.7 344.8",
  fill: "none",
  stroke: "url(#bg0_svg__V)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__W",
  gradientUnits: "userSpaceOnUse",
  x1: -202.97,
  y1: 3064.968,
  x2: 161.671,
  y2: 3064.968,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-185.4 55.1C-273.3 317.8 5.6 311 3.3 524.2c-2.1 185.6 158 210.4 158 345",
  fill: "none",
  stroke: "url(#bg0_svg__W)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__X",
  gradientUnits: "userSpaceOnUse",
  x1: -204.796,
  y1: 3065.116,
  x2: 152.171,
  y2: 3065.116,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-187.8 54.8C-272.7 317.5-3.7 315.5-2.7 523.9c1 180.1 154.5 208.6 154.5 345.3",
  fill: "none",
  stroke: "url(#bg0_svg__X)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__Y",
  gradientUnits: "userSpaceOnUse",
  x1: -206.627,
  y1: 3065.314,
  x2: 142.571,
  y2: 3065.314,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-190.2 54.4C-272.1 317.1-13.1 320-8.6 523.6c3.9 174.5 150.8 206.9 150.8 345.6",
  fill: "none",
  stroke: "url(#bg0_svg__Y)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__Z",
  gradientUnits: "userSpaceOnUse",
  x1: -208.457,
  y1: 3065.462,
  x2: 133.071,
  y2: 3065.462,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-192.6 54.1C-271.5 316.7-22.5 324.5-14.5 523.3c6.7 168.9 147.2 205.1 147.2 345.9",
  fill: "none",
  stroke: "url(#bg0_svg__Z)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aa",
  gradientUnits: "userSpaceOnUse",
  x1: -210.288,
  y1: 3065.56,
  x2: 123.471,
  y2: 3065.56,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-195 53.8C-270.9 316.4-31.9 329-20.5 523.1c9.6 163.3 143.6 203.3 143.6 346.2",
  fill: "none",
  stroke: "url(#bg0_svg__aa)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ab",
  gradientUnits: "userSpaceOnUse",
  x1: -212.184,
  y1: 3065.758,
  x2: 113.971,
  y2: 3065.758,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-197.5 53.5C-270.3 316-41.3 333.5-26.4 522.8c12.5 157.7 140 201.5 140 346.4",
  fill: "none",
  stroke: "url(#bg0_svg__ab)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ac",
  gradientUnits: "userSpaceOnUse",
  x1: -214.019,
  y1: 3065.956,
  x2: 104.471,
  y2: 3065.956,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-199.9 53.1C-269.7 315.7-50.8 337.9-32.3 522.5-17 674.6 104.1 722.3 104.1 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__ac)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ad",
  gradientUnits: "userSpaceOnUse",
  x1: -215.891,
  y1: 3066.104,
  x2: 94.871,
  y2: 3066.104,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-202.3 52.8c-66.9 262.5 141.9 289.6 164 469.4 18 146.5 132.8 198 132.8 347",
  fill: "none",
  stroke: "url(#bg0_svg__ad)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ae",
  gradientUnits: "userSpaceOnUse",
  x1: -217.696,
  y1: 3066.251,
  x2: 85.371,
  y2: 3066.251,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-204.7 52.5C-268.5 315-69.9 346.9-44.2 522-23.4 662.9 85 718.2 85 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__ae)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__af",
  gradientUnits: "userSpaceOnUse",
  x1: -219.572,
  y1: 3066.399,
  x2: 75.871,
  y2: 3066.399,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-207.1 52.2C-268 314.6-79.6 351.4-50.1 521.7-26.7 657 75.5 716.2 75.5 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__af)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ag",
  gradientUnits: "userSpaceOnUse",
  x1: -221.413,
  y1: 3066.497,
  x2: 66.371,
  y2: 3066.497,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-209.5 51.9C-267.4 314.3-89.2 355.9-56 521.5-30 651.2 66 714.2 66 869.3",
  fill: "none",
  stroke: "url(#bg0_svg__ag)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ah",
  gradientUnits: "userSpaceOnUse",
  x1: -223.264,
  y1: 3066.745,
  x2: 56.771,
  y2: 3066.745,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-211.9 51.5C-266.8 313.9-99 360.3-61.9 521.1c28.5 124.2 118.3 191 118.3 348.1",
  fill: "none",
  stroke: "url(#bg0_svg__ah)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ai",
  gradientUnits: "userSpaceOnUse",
  x1: -225.115,
  y1: 3066.893,
  x2: 47.271,
  y2: 3066.893,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-214.3 51.2c-51.9 262.4 105.5 313.6 146.4 469.7C-36.8 639.5 46.9 710 46.9 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__ai)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aj",
  gradientUnits: "userSpaceOnUse",
  x1: -226.972,
  y1: 3067.041,
  x2: 37.671,
  y2: 3067.041,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-216.7 50.9c-48.9 262.3 98 318.5 142.9 469.7C-40.2 633.6 37.3 708 37.3 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__aj)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ak",
  gradientUnits: "userSpaceOnUse",
  x1: -228.897,
  y1: 3067.189,
  x2: 28.171,
  y2: 3067.189,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-219.2 50.6C-265 312.9-128.7 374-79.7 520.3c36 107.5 107.5 185.6 107.5 348.9",
  fill: "none",
  stroke: "url(#bg0_svg__ak)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__al",
  gradientUnits: "userSpaceOnUse",
  x1: -230.765,
  y1: 3067.387,
  x2: 18.571,
  y2: 3067.387,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-221.6 50.2c-42.8 262.3 82.8 328.4 135.9 469.9 38.4 102 103.9 183.8 103.9 349.1",
  fill: "none",
  stroke: "url(#bg0_svg__al)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__am",
  gradientUnits: "userSpaceOnUse",
  x1: -232.671,
  y1: 3067.534,
  x2: 9.071,
  y2: 3067.534,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-224 49.9c-39.9 262.2 75 333.4 132.4 469.9C-51 616.4 8.7 701.9 8.7 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__am)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__an",
  gradientUnits: "userSpaceOnUse",
  x1: -234.52,
  y1: 3067.682,
  x2: -0.429,
  y2: 3067.682,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-226.4 49.6c-36.8 262.2 67.1 338.5 128.9 469.9C-54.6 610.8-.8 699.8-.8 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__an)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ao",
  gradientUnits: "userSpaceOnUse",
  x1: -236.436,
  y1: 3067.78,
  x2: -10.029,
  y2: 3067.78,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-228.8 49.3c-33.9 262.2 59.2 343.8 125.3 470 45.1 86 93.1 178.5 93.1 350",
  fill: "none",
  stroke: "url(#bg0_svg__ao)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ap",
  gradientUnits: "userSpaceOnUse",
  x1: -238.318,
  y1: 3067.977,
  x2: -19.529,
  y2: 3067.977,
  gradientTransform: "matrix(1 0 0 -1 0 3527.027)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-231.2 49C-282.7 486.4-19.9 436.2-19.9 869.2",
  fill: "none",
  stroke: "url(#bg0_svg__ap)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg0_svg__aq",
  d: "M592.9-2.1h853.3v809H592.9z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bg0_svg__ar"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg0_svg__aq",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg0_svg__ar)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__as",
  gradientUnits: "userSpaceOnUse",
  x1: 1427.764,
  y1: 1472.159,
  x2: 2257.541,
  y2: 1472.159,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1373.7-639.8c55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6",
  fill: "none",
  stroke: "url(#bg0_svg__as)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__at",
  gradientUnits: "userSpaceOnUse",
  x1: 1428.708,
  y1: 1468.247,
  x2: 2264.475,
  y2: 1468.247,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1372.8-638.9c54.6 66.7 84.5 41.7 139.1 108.4 54.6 66.7 24.7 91.8 79.4 158.5 54.6 66.7 84.5 41.7 139.1 108.4 54.6 66.7 24.7 91.8 79.4 158.5 54.6 66.7 84.5 41.7 139.1 108.4 54.6 66.7 24.7 91.8 79.4 158.5 54.6 66.7 84.5 41.7 139.1 108.4",
  fill: "none",
  stroke: "url(#bg0_svg__at)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__au",
  gradientUnits: "userSpaceOnUse",
  x1: 1429.653,
  y1: 1464.336,
  x2: 2271.409,
  y2: 1464.336,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1371.9-638.1C1426-571 1456-596 1510.1-528.8c54.1 67.1 24.2 92.1 78.3 159.2 54.1 67.1 84.1 42.1 138.2 109.3 54.1 67.1 24.2 92.1 78.3 159.2C1859-34 1889-59 1943.1 8.2c54.1 67.1 24.2 92.1 78.3 159.2s84.1 42.1 138.2 109.3",
  fill: "none",
  stroke: "url(#bg0_svg__au)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__av",
  gradientUnits: "userSpaceOnUse",
  x1: 1430.598,
  y1: 1460.424,
  x2: 2278.343,
  y2: 1460.424,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1371.1-637.2c53.7 67.5 83.7 42.6 137.3 110.1 53.7 67.5 23.6 92.4 77.3 159.9 53.7 67.5 83.7 42.6 137.3 110.1 53.7 67.5 23.7 92.4 77.3 159.9 53.7 67.5 83.7 42.6 137.3 110.1 53.7 67.5 23.7 92.4 77.3 159.9 53.7 67.5 83.7 42.6 137.3 110.1",
  fill: "none",
  stroke: "url(#bg0_svg__av)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aw",
  gradientUnits: "userSpaceOnUse",
  x1: 1431.543,
  y1: 1456.513,
  x2: 2285.277,
  y2: 1456.513,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1370.2-636.3c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.5c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.6c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.6c53.2 67.9 83.2 43.1 136.4 111",
  fill: "none",
  stroke: "url(#bg0_svg__aw)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ax",
  gradientUnits: "userSpaceOnUse",
  x1: 1432.488,
  y1: 1452.601,
  x2: 2292.211,
  y2: 1452.601,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1369.3-635.5c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.2 161.2c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.3 161.2c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.3 161.2c52.7 68.3 82.8 43.5 135.5 111.8",
  fill: "none",
  stroke: "url(#bg0_svg__ax)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ay",
  gradientUnits: "userSpaceOnUse",
  x1: 1433.433,
  y1: 1448.689,
  x2: 2299.145,
  y2: 1448.689,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1368.4-634.6c52.2 68.6 82.4 44 134.6 112.6 52.2 68.6 22 93.3 74.2 161.9 52.2 68.6 82.4 44 134.6 112.6 52.2 68.6 22 93.3 74.2 161.9 52.2 68.6 82.4 44 134.6 112.6 52.2 68.6 22 93.3 74.2 161.9 52.2 68.6 82.4 44 134.6 112.7",
  fill: "none",
  stroke: "url(#bg0_svg__ay)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__az",
  gradientUnits: "userSpaceOnUse",
  x1: 1434.378,
  y1: 1444.778,
  x2: 2306.079,
  y2: 1444.778,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1367.5-633.7c51.7 69 82 44.5 133.7 113.5 51.7 69 21.5 93.6 73.2 162.6s82 44.5 133.7 113.5c51.7 69 21.5 93.6 73.2 162.6S1863.3-37 1915 32c51.7 69 21.5 93.6 73.2 162.6s82 44.5 133.7 113.5",
  fill: "none",
  stroke: "url(#bg0_svg__az)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aA",
  gradientUnits: "userSpaceOnUse",
  x1: 1435.323,
  y1: 1440.866,
  x2: 2313.013,
  y2: 1440.866,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1366.7-632.9c51.2 69.4 81.5 44.9 132.8 114.3 51.2 69.4 20.9 93.9 72.2 163.3 51.2 69.4 81.5 44.9 132.8 114.3 51.2 69.4 20.9 93.9 72.2 163.3 51.2 69.4 81.5 44.9 132.8 114.3 51.2 69.4 20.9 93.9 72.2 163.3 51.2 69.4 81.5 44.9 132.8 114.3",
  fill: "none",
  stroke: "url(#bg0_svg__aA)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aB",
  gradientUnits: "userSpaceOnUse",
  x1: 1436.268,
  y1: 1436.954,
  x2: 2319.947,
  y2: 1436.954,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1365.8-632c50.7 69.8 81.1 45.4 131.8 115.2 50.7 69.8 20.4 94.2 71.1 163.9 50.7 69.8 81.1 45.4 131.8 115.2 50.7 69.8 20.4 94.2 71.1 163.9 50.7 69.8 81.1 45.4 131.8 115.2 50.7 69.8 20.4 94.2 71.1 163.9 50.7 69.8 81.1 45.4 131.9 115.2",
  fill: "none",
  stroke: "url(#bg0_svg__aB)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aC",
  gradientUnits: "userSpaceOnUse",
  x1: 1437.213,
  y1: 1433.043,
  x2: 2326.881,
  y2: 1433.043,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1364.9-631.1c50.3 70.2 80.7 45.9 130.9 116 50.3 70.2 19.8 94.5 70.1 164.6 50.3 70.2 80.7 45.9 130.9 116 50.3 70.2 19.9 94.5 70.1 164.6 50.3 70.2 80.7 45.9 130.9 116 50.3 70.2 19.9 94.5 70.1 164.6s80.7 45.9 130.9 116",
  fill: "none",
  stroke: "url(#bg0_svg__aC)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aD",
  gradientUnits: "userSpaceOnUse",
  x1: 1438.158,
  y1: 1429.131,
  x2: 2333.815,
  y2: 1429.131,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1364-630.3c49.8 70.5 80.2 46.3 130 116.9 49.8 70.5 19.3 94.7 69.1 165.3 49.8 70.5 80.2 46.3 130 116.9 49.8 70.5 19.3 94.7 69.1 165.3 49.8 70.5 80.2 46.3 130 116.9 49.8 70.5 19.3 94.8 69.1 165.3 49.8 70.5 80.2 46.3 130 116.9",
  fill: "none",
  stroke: "url(#bg0_svg__aD)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aE",
  gradientUnits: "userSpaceOnUse",
  x1: 1439.102,
  y1: 1425.219,
  x2: 2340.749,
  y2: 1425.219,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1363.1-629.4c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166c49.3 70.9 79.8 46.8 129.1 117.7",
  fill: "none",
  stroke: "url(#bg0_svg__aE)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aF",
  gradientUnits: "userSpaceOnUse",
  x1: 1440.048,
  y1: 1421.308,
  x2: 2347.683,
  y2: 1421.308,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1362.3-628.5c48.8 71.3 79.4 47.3 128.2 118.6 48.8 71.3 18.2 95.3 67 166.6s79.4 47.3 128.2 118.6c48.8 71.3 18.2 95.3 67 166.6s79.4 47.3 128.2 118.6c48.8 71.3 18.2 95.3 67 166.7 48.8 71.3 79.4 47.3 128.2 118.6",
  fill: "none",
  stroke: "url(#bg0_svg__aF)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aG",
  gradientUnits: "userSpaceOnUse",
  x1: 1440.993,
  y1: 1417.396,
  x2: 2354.617,
  y2: 1417.396,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1361.4-627.7c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3c48.3 71.7 79 47.7 127.3 119.4",
  fill: "none",
  stroke: "url(#bg0_svg__aG)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aH",
  gradientUnits: "userSpaceOnUse",
  x1: 1441.938,
  y1: 1413.484,
  x2: 2361.55,
  y2: 1413.484,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1360.5-626.8c47.8 72.1 78.5 48.2 126.4 120.3 47.8 72.1 17.1 95.9 65 168 47.8 72.1 78.5 48.2 126.4 120.3 47.8 72.1 17.1 95.9 65 168 47.7 72 78.4 48.1 126.3 120.2 47.8 72.1 17.1 95.9 65 168 47.8 72.1 78.5 48.2 126.4 120.3",
  fill: "none",
  stroke: "url(#bg0_svg__aH)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aI",
  gradientUnits: "userSpaceOnUse",
  x1: 1442.883,
  y1: 1409.573,
  x2: 2368.485,
  y2: 1409.573,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1359.6-625.9c47.4 72.4 78.1 48.7 125.5 121.1 47.4 72.4 16.6 96.2 63.9 168.7 47.4 72.4 78.1 48.7 125.5 121.1 47.4 72.4 16.6 96.2 63.9 168.7 47.4 72.4 78.1 48.7 125.5 121.1 47.4 72.5 16.6 96.2 64 168.7 47.4 72.5 78.1 48.7 125.5 121.1",
  fill: "none",
  stroke: "url(#bg0_svg__aI)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aJ",
  gradientUnits: "userSpaceOnUse",
  x1: 1443.828,
  y1: 1405.661,
  x2: 2375.419,
  y2: 1405.661,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1358.7-625c46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 62.9 169.4 46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 62.9 169.4 46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 62.9 169.4 46.9 72.8 77.7 49.1 124.6 122",
  fill: "none",
  stroke: "url(#bg0_svg__aJ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aK",
  gradientUnits: "userSpaceOnUse",
  x1: 1444.773,
  y1: 1401.749,
  x2: 2382.352,
  y2: 1401.749,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1357.9-624.2c46.4 73.2 77.3 49.6 123.6 122.8 46.4 73.2 15.5 96.8 61.9 170s77.3 49.6 123.6 122.8c46.4 73.2 15.5 96.8 61.9 170s77.3 49.6 123.6 122.8c46.4 73.2 15.5 96.8 61.9 170s77.3 49.6 123.6 122.8",
  fill: "none",
  stroke: "url(#bg0_svg__aK)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aL",
  gradientUnits: "userSpaceOnUse",
  x1: 1445.718,
  y1: 1397.838,
  x2: 2389.286,
  y2: 1397.838,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1357-623.3c45.9 73.6 76.8 50.1 122.7 123.6 45.9 73.6 15 97.1 60.9 170.7s76.8 50.1 122.7 123.6c45.9 73.6 15 97.1 60.9 170.7S1801 15.4 1846.9 89c45.9 73.6 15 97.1 60.9 170.7s76.8 50.1 122.7 123.7",
  fill: "none",
  stroke: "url(#bg0_svg__aL)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aM",
  gradientUnits: "userSpaceOnUse",
  x1: 1446.663,
  y1: 1393.926,
  x2: 2396.22,
  y2: 1393.926,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1356.1-622.4c45.4 74 76.4 50.5 121.8 124.5 45.4 74 14.4 97.4 59.8 171.4s76.4 50.5 121.8 124.5c45.4 74 14.4 97.4 59.8 171.4s76.4 50.5 121.8 124.5c45.4 74 14.4 97.4 59.8 171.4s76.4 50.5 121.8 124.5",
  fill: "none",
  stroke: "url(#bg0_svg__aM)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aN",
  gradientUnits: "userSpaceOnUse",
  x1: 1447.608,
  y1: 1390.014,
  x2: 2403.154,
  y2: 1390.014,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1355.2-621.6c44.9 74.4 76 51 120.9 125.3 44.9 74.4 13.9 97.7 58.8 172.1 44.9 74.4 76 51 120.9 125.3 44.9 74.4 13.9 97.7 58.8 172.1 44.9 74.4 76 51 120.9 125.3 44.9 74.4 13.9 97.7 58.8 172.1 44.9 74.4 76 51 120.9 125.4",
  fill: "none",
  stroke: "url(#bg0_svg__aN)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aO",
  gradientUnits: "userSpaceOnUse",
  x1: 1448.553,
  y1: 1386.103,
  x2: 2410.088,
  y2: 1386.103,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1354.3-620.7c44.4 74.7 75.6 51.5 120 126.2 44.4 74.7 13.3 98 57.8 172.7 44.4 74.7 75.6 51.5 120 126.2 44.4 74.7 13.3 98 57.8 172.7 44.4 74.7 75.6 51.5 120 126.2 44.4 74.7 13.3 98 57.8 172.7 44.4 74.7 75.6 51.5 120 126.2",
  fill: "none",
  stroke: "url(#bg0_svg__aO)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aP",
  gradientUnits: "userSpaceOnUse",
  x1: 1449.498,
  y1: 1382.191,
  x2: 2417.021,
  y2: 1382.191,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1353.4-619.8c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4c44 75.1 75.1 51.9 119.1 127",
  fill: "none",
  stroke: "url(#bg0_svg__aP)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aQ",
  gradientUnits: "userSpaceOnUse",
  x1: 1450.443,
  y1: 1378.28,
  x2: 2423.955,
  y2: 1378.28,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1352.6-619c43.5 75.5 74.7 52.4 118.2 127.9s12.3 98.6 55.7 174.1c43.5 75.5 74.7 52.4 118.2 127.9S1657-90.5 1700.4-15c43.5 75.5 74.7 52.4 118.2 127.9s12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9",
  fill: "none",
  stroke: "url(#bg0_svg__aQ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aR",
  gradientUnits: "userSpaceOnUse",
  x1: 1451.388,
  y1: 1374.368,
  x2: 2430.889,
  y2: 1374.368,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1351.7-618.1c43 75.9 74.3 52.9 117.3 128.7 43 75.9 11.7 98.9 54.7 174.8s74.3 52.9 117.3 128.7c43 75.9 11.7 98.9 54.7 174.8S1770 41.8 1813 117.6c43 75.9 11.7 98.9 54.7 174.8s74.3 52.9 117.3 128.7",
  fill: "none",
  stroke: "url(#bg0_svg__aR)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aS",
  gradientUnits: "userSpaceOnUse",
  x1: 1452.333,
  y1: 1370.456,
  x2: 2437.823,
  y2: 1370.456,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1350.8-617.2c42.5 76.3 73.8 53.3 116.4 129.6 42.5 76.3 11.2 99.2 53.7 175.4 42.5 76.3 73.8 53.3 116.4 129.6 42.5 76.3 11.2 99.2 53.7 175.5s73.8 53.3 116.4 129.6c42.5 76.3 11.2 99.2 53.7 175.5s73.8 53.3 116.4 129.6",
  fill: "none",
  stroke: "url(#bg0_svg__aS)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aT",
  gradientUnits: "userSpaceOnUse",
  x1: 1459.267,
  y1: 1366.545,
  x2: 2438.768,
  y2: 1366.545,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1343.2-610.9c43 75.9 74.3 52.9 117.3 128.7 43 75.9 11.7 98.9 54.7 174.8s74.3 52.9 117.3 128.7c43 75.9 11.7 98.9 54.7 174.8s74.3 52.9 117.3 128.7c43 75.9 11.7 98.9 54.7 174.8s74.3 52.9 117.3 128.7",
  fill: "none",
  stroke: "url(#bg0_svg__aT)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aU",
  gradientUnits: "userSpaceOnUse",
  x1: 1466.201,
  y1: 1362.633,
  x2: 2439.713,
  y2: 1362.633,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1335.6-604.7c43.5 75.5 74.7 52.4 118.2 127.9s12.3 98.6 55.7 174.1c43.5 75.5 74.7 52.4 118.2 127.9S1640-76.2 1683.4-.7c43.5 75.5 74.7 52.4 118.2 127.9s12.3 98.6 55.7 174.1c43.5 75.5 74.7 52.4 118.2 127.9",
  fill: "none",
  stroke: "url(#bg0_svg__aU)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aV",
  gradientUnits: "userSpaceOnUse",
  x1: 1473.135,
  y1: 1358.721,
  x2: 2440.658,
  y2: 1358.721,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1328-598.4c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4c44 75.1 75.1 51.9 119.1 127",
  fill: "none",
  stroke: "url(#bg0_svg__aV)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aW",
  gradientUnits: "userSpaceOnUse",
  x1: 1480.069,
  y1: 1354.81,
  x2: 2441.604,
  y2: 1354.81,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1320.4-592.1c44.4 74.7 75.6 51.5 120 126.2 44.4 74.7 13.3 98 57.8 172.7 44.4 74.7 75.6 51.5 120 126.2 44.4 74.7 13.3 98 57.8 172.7 44.4 74.7 75.6 51.5 120 126.2 44.4 74.7 13.3 98 57.8 172.7 44.4 74.7 75.6 51.5 120 126.2",
  fill: "none",
  stroke: "url(#bg0_svg__aW)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aX",
  gradientUnits: "userSpaceOnUse",
  x1: 1487.002,
  y1: 1350.898,
  x2: 2442.549,
  y2: 1350.898,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1312.8-585.8c44.9 74.4 76 51 120.9 125.3 44.9 74.4 13.9 97.7 58.8 172.1 44.9 74.4 76 51 120.9 125.3 44.9 74.4 13.9 97.7 58.8 172.1 44.9 74.4 76 51 120.9 125.3 44.9 74.4 13.9 97.7 58.8 172.1 44.9 74.4 76 51 120.9 125.4",
  fill: "none",
  stroke: "url(#bg0_svg__aX)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aY",
  gradientUnits: "userSpaceOnUse",
  x1: 1493.936,
  y1: 1346.986,
  x2: 2443.494,
  y2: 1346.986,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1305.1-579.5c45.4 74 76.4 50.5 121.8 124.5 45.4 74 14.4 97.4 59.8 171.4s76.4 50.5 121.8 124.5c45.4 74 14.4 97.4 59.8 171.4s76.4 50.5 121.8 124.5c45.4 74 14.4 97.4 59.8 171.4s76.4 50.5 121.8 124.5",
  fill: "none",
  stroke: "url(#bg0_svg__aY)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__aZ",
  gradientUnits: "userSpaceOnUse",
  x1: 1500.87,
  y1: 1343.075,
  x2: 2444.439,
  y2: 1343.075,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1297.5-573.2c45.9 73.6 76.8 50.1 122.7 123.6 45.9 73.6 15 97.1 60.9 170.7s76.8 50.1 122.7 123.6c45.9 73.6 15 97.1 60.9 170.7s76.8 50.1 122.7 123.7c45.9 73.6 15 97.1 60.9 170.7s76.8 50.1 122.7 123.7",
  fill: "none",
  stroke: "url(#bg0_svg__aZ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ba",
  gradientUnits: "userSpaceOnUse",
  x1: 1507.804,
  y1: 1339.163,
  x2: 2445.384,
  y2: 1339.163,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1289.9-566.9c46.4 73.2 77.3 49.6 123.6 122.8 46.4 73.2 15.5 96.8 61.9 170s77.3 49.6 123.6 122.8c46.4 73.2 15.5 96.8 61.9 170s77.3 49.6 123.6 122.8c46.4 73.2 15.5 96.8 61.9 170s77.3 49.6 123.6 122.8",
  fill: "none",
  stroke: "url(#bg0_svg__ba)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bb",
  gradientUnits: "userSpaceOnUse",
  x1: 1514.738,
  y1: 1335.251,
  x2: 2446.329,
  y2: 1335.251,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1282.3-560.7c46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 62.9 169.4 46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 62.9 169.4 46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 62.9 169.4 46.9 72.8 77.7 49.1 124.6 122",
  fill: "none",
  stroke: "url(#bg0_svg__bb)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bc",
  gradientUnits: "userSpaceOnUse",
  x1: 1521.672,
  y1: 1331.34,
  x2: 2447.274,
  y2: 1331.34,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1274.7-554.4c47.4 72.4 78.1 48.7 125.5 121.1 47.4 72.4 16.6 96.2 63.9 168.7 47.4 72.4 78.1 48.7 125.5 121.1 47.4 72.4 16.6 96.2 63.9 168.7 47.4 72.4 78.1 48.7 125.5 121.1 47.4 72.5 16.6 96.2 64 168.7 47.4 72.5 78.1 48.7 125.5 121.1",
  fill: "none",
  stroke: "url(#bg0_svg__bc)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bd",
  gradientUnits: "userSpaceOnUse",
  x1: 1528.606,
  y1: 1327.428,
  x2: 2448.219,
  y2: 1327.428,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1267.1-548.1c47.8 72.1 78.5 48.2 126.4 120.3 47.8 72.1 17.1 95.9 65 168 47.8 72.1 78.5 48.2 126.4 120.3 47.8 72.1 17.1 95.9 65 168 47.8 72.1 78.5 48.2 126.4 120.3 47.8 72.1 17.1 95.9 65 168 47.8 72.1 78.5 48.2 126.4 120.3",
  fill: "none",
  stroke: "url(#bg0_svg__bd)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__be",
  gradientUnits: "userSpaceOnUse",
  x1: 1535.54,
  y1: 1323.516,
  x2: 2449.164,
  y2: 1323.516,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5-541.8c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3 79 47.7 127.3 119.4",
  fill: "none",
  stroke: "url(#bg0_svg__be)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bf",
  gradientUnits: "userSpaceOnUse",
  x1: 1542.474,
  y1: 1319.605,
  x2: 2450.109,
  y2: 1319.605,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1251.9-535.5c48.8 71.3 79.4 47.3 128.2 118.6 48.8 71.3 18.2 95.3 67 166.6s79.4 47.3 128.2 118.6c48.8 71.3 18.2 95.3 67 166.6s79.4 47.3 128.2 118.6c48.8 71.3 18.2 95.3 67 166.7 48.8 71.3 79.4 47.3 128.2 118.6",
  fill: "none",
  stroke: "url(#bg0_svg__bf)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bg",
  gradientUnits: "userSpaceOnUse",
  x1: 1549.408,
  y1: 1315.693,
  x2: 2451.054,
  y2: 1315.693,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1244.3-529.2c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166 79.8 46.8 129.1 117.7",
  fill: "none",
  stroke: "url(#bg0_svg__bg)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bh",
  gradientUnits: "userSpaceOnUse",
  x1: 1556.341,
  y1: 1311.782,
  x2: 2451.999,
  y2: 1311.782,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1236.7-522.9c49.8 70.5 80.2 46.3 130 116.9 49.8 70.5 19.3 94.7 69.1 165.3 49.8 70.5 80.2 46.3 130 116.9 49.8 70.5 19.3 94.7 69.1 165.3 49.8 70.5 80.2 46.3 130 116.9 49.8 70.5 19.3 94.8 69.1 165.3 49.8 70.5 80.2 46.3 130 116.9",
  fill: "none",
  stroke: "url(#bg0_svg__bh)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bi",
  gradientUnits: "userSpaceOnUse",
  x1: 1563.275,
  y1: 1307.87,
  x2: 2452.944,
  y2: 1307.87,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1229-516.6c50.3 70.2 80.7 45.9 130.9 116 50.3 70.2 19.8 94.5 70.1 164.6 50.3 70.2 80.7 45.9 130.9 116 50.3 70.2 19.9 94.5 70.1 164.6 50.3 70.2 80.7 45.9 130.9 116 50.3 70.2 19.9 94.5 70.1 164.6 50.3 70.2 80.7 45.9 130.9 116",
  fill: "none",
  stroke: "url(#bg0_svg__bi)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bj",
  gradientUnits: "userSpaceOnUse",
  x1: 1570.209,
  y1: 1303.958,
  x2: 2453.889,
  y2: 1303.958,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1221.4-510.4c50.7 69.8 81.1 45.4 131.8 115.2 50.7 69.8 20.4 94.2 71.1 163.9 50.7 69.8 81.1 45.4 131.8 115.2 50.7 69.8 20.4 94.2 71.1 163.9 50.7 69.8 81.1 45.4 131.8 115.2 50.7 69.8 20.4 94.2 71.1 163.9s81.1 45.4 131.9 115.2",
  fill: "none",
  stroke: "url(#bg0_svg__bj)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bk",
  gradientUnits: "userSpaceOnUse",
  x1: 1577.143,
  y1: 1300.046,
  x2: 2454.834,
  y2: 1300.046,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1213.8-504.1c51.2 69.4 81.5 44.9 132.8 114.3 51.2 69.4 20.9 93.9 72.2 163.3 51.2 69.4 81.5 44.9 132.8 114.3 51.2 69.4 20.9 93.9 72.2 163.3 51.2 69.4 81.5 44.9 132.8 114.3 51.2 69.4 20.9 93.9 72.2 163.3 51.2 69.4 81.5 44.9 132.8 114.3",
  fill: "none",
  stroke: "url(#bg0_svg__bk)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bl",
  gradientUnits: "userSpaceOnUse",
  x1: 1584.077,
  y1: 1296.135,
  x2: 2455.779,
  y2: 1296.135,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1206.2-497.8c51.7 69 82 44.5 133.7 113.5 51.7 69 21.5 93.6 73.2 162.6s82 44.5 133.7 113.5c51.7 69 21.5 93.6 73.2 162.6s82 44.5 133.7 113.5c51.7 69 21.5 93.6 73.2 162.6s82 44.5 133.7 113.5",
  fill: "none",
  stroke: "url(#bg0_svg__bl)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bm",
  gradientUnits: "userSpaceOnUse",
  x1: 1591.011,
  y1: 1292.223,
  x2: 2456.724,
  y2: 1292.223,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1198.6-491.5c52.2 68.6 82.4 44 134.6 112.6 52.2 68.6 22 93.3 74.2 161.9 52.2 68.6 82.4 44 134.6 112.6 52.2 68.6 22 93.3 74.2 161.9 52.2 68.6 82.4 44 134.6 112.6 52.2 68.6 22 93.3 74.2 161.9 52.2 68.6 82.4 44 134.6 112.7",
  fill: "none",
  stroke: "url(#bg0_svg__bm)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bn",
  gradientUnits: "userSpaceOnUse",
  x1: 1597.945,
  y1: 1288.312,
  x2: 2457.669,
  y2: 1288.312,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1191-485.2c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.2 161.2c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.3 161.2c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.3 161.2 82.8 43.5 135.5 111.8",
  fill: "none",
  stroke: "url(#bg0_svg__bn)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bo",
  gradientUnits: "userSpaceOnUse",
  x1: 1604.879,
  y1: 1284.4,
  x2: 2458.613,
  y2: 1284.4,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1183.4-478.9c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.5c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.6c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.6c53.2 67.9 83.2 43.1 136.4 111",
  fill: "none",
  stroke: "url(#bg0_svg__bo)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bp",
  gradientUnits: "userSpaceOnUse",
  x1: 1611.813,
  y1: 1280.488,
  x2: 2459.558,
  y2: 1280.488,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1175.8-472.6c53.7 67.5 83.7 42.6 137.3 110.1 53.7 67.5 23.6 92.4 77.3 159.9 53.7 67.5 83.7 42.6 137.3 110.1C1581.4-25 1551.3-.1 1605 67.4c53.7 67.5 83.7 42.6 137.3 110.1 53.7 67.5 23.7 92.4 77.3 159.9 53.7 67.5 83.7 42.6 137.3 110.1",
  fill: "none",
  stroke: "url(#bg0_svg__bp)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bq",
  gradientUnits: "userSpaceOnUse",
  x1: 1618.747,
  y1: 1276.577,
  x2: 2460.503,
  y2: 1276.577,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1168.2-466.4c54.1 67.1 84.1 42.1 138.2 109.3 54.1 67.1 24.2 92.1 78.3 159.2 54.1 67.1 84.1 42.1 138.2 109.3 54.1 67.1 24.2 92.1 78.3 159.2 54.1 67.1 84.1 42.1 138.2 109.3 54.1 67.1 24.2 92.1 78.3 159.2s84.1 42.1 138.2 109.3",
  fill: "none",
  stroke: "url(#bg0_svg__bq)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__br",
  gradientUnits: "userSpaceOnUse",
  x1: 1625.681,
  y1: 1272.665,
  x2: 2461.448,
  y2: 1272.665,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1160.6-460.1c54.6 66.7 84.5 41.7 139.1 108.4 54.6 66.7 24.7 91.8 79.4 158.5 54.6 66.7 84.5 41.7 139.1 108.4 54.6 66.7 24.7 91.8 79.4 158.5 54.6 66.7 84.5 41.7 139.1 108.4 54.6 66.7 24.7 91.8 79.4 158.5 54.6 66.7 84.5 41.7 139.1 108.4",
  fill: "none",
  stroke: "url(#bg0_svg__br)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bs",
  gradientUnits: "userSpaceOnUse",
  x1: 1632.616,
  y1: 1268.753,
  x2: 2462.393,
  y2: 1268.753,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1153-453.8c55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6",
  fill: "none",
  stroke: "url(#bg0_svg__bs)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bt",
  gradientUnits: "userSpaceOnUse",
  x1: 1639.638,
  y1: 1264.685,
  x2: 2463.564,
  y2: 1264.685,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1145.6-447.4c55.5 66 85.3 40.8 140.8 106.7 55.5 66 25.8 91.2 81.3 157.1 55.5 66 85.3 40.8 140.8 106.7 55.5 66 25.8 91.2 81.3 157.2 55.5 66 85.3 40.8 140.8 106.7 55.5 66 25.8 91.2 81.3 157.2 55.5 66 85.3 40.8 140.8 106.7",
  fill: "none",
  stroke: "url(#bg0_svg__bt)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bu",
  gradientUnits: "userSpaceOnUse",
  x1: 1646.661,
  y1: 1260.617,
  x2: 2464.736,
  y2: 1260.617,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1138.3-441c56 65.6 85.7 40.3 141.6 105.9 56 65.6 26.3 90.9 82.2 156.5 56 65.6 85.7 40.3 141.6 105.9 56 65.6 26.3 90.9 82.2 156.5 56 65.6 85.7 40.3 141.6 105.9 56 65.6 26.3 90.9 82.2 156.5 56 65.6 85.7 40.3 141.6 105.9",
  fill: "none",
  stroke: "url(#bg0_svg__bu)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bv",
  gradientUnits: "userSpaceOnUse",
  x1: 1653.684,
  y1: 1256.549,
  x2: 2465.907,
  y2: 1256.549,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1130.9-434.6c56.4 65.2 86 39.9 142.4 105.1 56.4 65.2 26.7 90.6 83.1 155.8 56.4 65.2 86 39.9 142.4 105.1 56.4 65.2 26.7 90.6 83.1 155.8 56.4 65.2 86 39.9 142.4 105.1 56.4 65.2 26.7 90.6 83.1 155.8 56.4 65.2 86 39.9 142.4 105.1",
  fill: "none",
  stroke: "url(#bg0_svg__bv)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bw",
  gradientUnits: "userSpaceOnUse",
  x1: 1660.707,
  y1: 1252.481,
  x2: 2467.078,
  y2: 1252.481,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1123.6-428.2c56.8 64.8 86.4 39.4 143.2 104.3 56.8 64.8 27.2 90.2 84 155.1 56.8 64.8 86.4 39.4 143.2 104.3 56.8 64.8 27.2 90.2 84 155.1 56.8 64.8 86.4 39.4 143.2 104.3 56.8 64.8 27.2 90.2 84 155.1 56.8 64.8 86.4 39.4 143.2 104.3",
  fill: "none",
  stroke: "url(#bg0_svg__bw)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bx",
  gradientUnits: "userSpaceOnUse",
  x1: 1667.73,
  y1: 1248.413,
  x2: 2468.249,
  y2: 1248.413,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1116.3-421.8c57.2 64.5 86.7 39 143.9 103.4 57.2 64.5 27.7 89.9 84.9 154.4s86.7 39 143.9 103.4c57.2 64.5 27.7 89.9 84.9 154.4s86.7 39 143.9 103.4c57.2 64.5 27.7 89.9 84.9 154.4s86.7 39 143.9 103.5",
  fill: "none",
  stroke: "url(#bg0_svg__bx)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__by",
  gradientUnits: "userSpaceOnUse",
  x1: 1674.752,
  y1: 1244.345,
  x2: 2469.42,
  y2: 1244.345,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1108.9-415.4c57.6 64.1 87.1 38.5 144.7 102.6 57.6 64.1 28.2 89.6 85.8 153.7 57.6 64.1 87.1 38.5 144.7 102.6 57.6 64.1 28.2 89.6 85.8 153.7 57.6 64.1 87.1 38.5 144.7 102.6 57.6 64.1 28.2 89.6 85.9 153.7 57.6 64.1 87.1 38.5 144.7 102.6",
  fill: "none",
  stroke: "url(#bg0_svg__by)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bz",
  gradientUnits: "userSpaceOnUse",
  x1: 1681.775,
  y1: 1240.276,
  x2: 2470.592,
  y2: 1240.276,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1101.6-409c58.1 63.7 87.4 38.1 145.5 101.8 58.1 63.7 28.7 89.3 86.8 153 58.1 63.7 87.4 38.1 145.5 101.8 58.1 63.7 28.7 89.3 86.8 153 58.1 63.7 87.4 38.1 145.5 101.8 58.1 63.7 28.7 89.3 86.8 153 58.1 63.7 87.4 38.1 145.5 101.8",
  fill: "none",
  stroke: "url(#bg0_svg__bz)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bA",
  gradientUnits: "userSpaceOnUse",
  x1: 1688.798,
  y1: 1236.208,
  x2: 2471.763,
  y2: 1236.208,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1094.3-402.6c58.5 63.3 87.8 37.7 146.3 101 58.5 63.3 29.2 89 87.7 152.3 58.5 63.3 87.8 37.7 146.3 101 58.5 63.3 29.2 89 87.7 152.3 58.5 63.3 87.8 37.7 146.3 101 58.5 63.3 29.2 89 87.7 152.3 58.5 63.3 87.8 37.7 146.3 101",
  fill: "none",
  stroke: "url(#bg0_svg__bA)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bB",
  gradientUnits: "userSpaceOnUse",
  x1: 1695.821,
  y1: 1232.14,
  x2: 2472.934,
  y2: 1232.14,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1086.9-396.2C1145.8-333.3 1175-359 1234-296c58.9 62.9 29.7 88.7 88.6 151.6 58.9 62.9 88.1 37.2 147.1 100.2 58.9 63 29.7 88.7 88.6 151.6 58.9 62.9 88.1 37.2 147.1 100.2 58.9 63 29.7 88.7 88.6 151.6 58.9 63 88.2 37.2 147.1 100.2",
  fill: "none",
  stroke: "url(#bg0_svg__bB)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bC",
  gradientUnits: "userSpaceOnUse",
  x1: 1702.844,
  y1: 1228.072,
  x2: 2474.105,
  y2: 1228.072,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1079.6-389.8c59.3 62.6 88.5 36.8 147.8 99.3 59.3 62.6 30.2 88.4 89.5 151 59.3 62.6 88.5 36.8 147.8 99.3 59.3 62.6 30.2 88.4 89.5 151 59.3 62.6 88.5 36.8 147.8 99.3 59.3 62.6 30.2 88.4 89.5 151 59.3 62.6 88.5 36.8 147.8 99.3",
  fill: "none",
  stroke: "url(#bg0_svg__bC)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bD",
  gradientUnits: "userSpaceOnUse",
  x1: 1709.867,
  y1: 1224.004,
  x2: 2475.276,
  y2: 1224.004,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1072.2-383.4c59.8 62.2 88.9 36.3 148.6 98.5 59.8 62.2 30.6 88.1 90.4 150.3 59.8 62.2 88.9 36.3 148.6 98.5 59.8 62.2 30.6 88.1 90.4 150.3 59.8 62.2 88.9 36.3 148.6 98.5 59.8 62.2 30.6 88.1 90.4 150.3 59.8 62.2 88.9 36.3 148.6 98.5",
  fill: "none",
  stroke: "url(#bg0_svg__bD)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bE",
  gradientUnits: "userSpaceOnUse",
  x1: 1716.89,
  y1: 1219.936,
  x2: 2476.448,
  y2: 1219.936,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1064.9-377c60.2 61.8 89.2 35.9 149.4 97.7 60.2 61.8 31.1 87.8 91.3 149.6 60.2 61.8 89.2 35.9 149.4 97.7 60.2 61.8 31.1 87.8 91.3 149.6 60.2 61.8 89.2 35.9 149.4 97.7 60.2 61.8 31.1 87.8 91.3 149.6 60.2 61.8 89.2 35.9 149.4 97.7",
  fill: "none",
  stroke: "url(#bg0_svg__bE)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bF",
  gradientUnits: "userSpaceOnUse",
  x1: 1723.913,
  y1: 1215.868,
  x2: 2477.618,
  y2: 1215.868,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1057.6-370.6c60.6 61.4 89.6 35.4 150.2 96.9 60.6 61.4 31.6 87.4 92.2 148.9 60.6 61.4 89.6 35.4 150.2 96.9 60.6 61.4 31.6 87.4 92.2 148.9 60.6 61.4 89.6 35.4 150.2 96.9 60.6 61.4 31.6 87.5 92.2 148.9 60.6 61.4 89.6 35.4 150.2 96.9",
  fill: "none",
  stroke: "url(#bg0_svg__bF)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bG",
  gradientUnits: "userSpaceOnUse",
  x1: 1730.936,
  y1: 1211.8,
  x2: 2478.79,
  y2: 1211.8,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1050.2-364.2c61 61.1 89.9 35 150.9 96 61 61.1 32.1 87.1 93.1 148.2 61 61.1 89.9 35 150.9 96 61 61.1 32.1 87.1 93.1 148.2 61 61.1 89.9 35 150.9 96 61 61.1 32.1 87.1 93.1 148.2 61 61.1 89.9 35 151 96",
  fill: "none",
  stroke: "url(#bg0_svg__bG)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bH",
  gradientUnits: "userSpaceOnUse",
  x1: 1737.959,
  y1: 1207.732,
  x2: 2479.961,
  y2: 1207.732,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1042.9-357.8c61.4 60.7 90.3 34.5 151.7 95.2 61.4 60.7 32.6 86.8 94 147.5s90.3 34.5 151.7 95.2c61.4 60.7 32.6 86.8 94 147.5s90.3 34.5 151.7 95.2c61.4 60.7 32.6 86.8 94 147.5s90.3 34.5 151.7 95.2",
  fill: "none",
  stroke: "url(#bg0_svg__bH)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bI",
  gradientUnits: "userSpaceOnUse",
  x1: 1744.982,
  y1: 1203.664,
  x2: 2481.132,
  y2: 1203.664,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1035.6-351.4c61.9 60.3 90.6 34.1 152.5 94.4 61.9 60.3 33.1 86.5 94.9 146.8 61.9 60.3 90.6 34.1 152.5 94.4 61.9 60.3 33.1 86.5 94.9 146.8 61.9 60.3 90.6 34.1 152.5 94.4 61.9 60.3 33.1 86.5 95 146.8 61.9 60.3 90.6 34.1 152.5 94.4",
  fill: "none",
  stroke: "url(#bg0_svg__bI)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bJ",
  gradientUnits: "userSpaceOnUse",
  x1: 1752.005,
  y1: 1199.595,
  x2: 2482.303,
  y2: 1199.595,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1028.2-345c62.3 59.9 91 33.6 153.3 93.6 62.3 59.9 33.6 86.2 95.9 146.1 62.3 59.9 91 33.6 153.3 93.6 62.3 59.9 33.6 86.2 95.9 146.1 62.3 59.9 91 33.6 153.3 93.6 62.3 59.9 33.6 86.2 95.9 146.1s91 33.6 153.3 93.6",
  fill: "none",
  stroke: "url(#bg0_svg__bJ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bK",
  gradientUnits: "userSpaceOnUse",
  x1: 1759.028,
  y1: 1195.527,
  x2: 2483.474,
  y2: 1195.527,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1020.9-338.6c62.7 59.5 91.4 33.2 154.1 92.7 62.7 59.5 34.1 85.9 96.8 145.4 62.7 59.5 91.4 33.2 154.1 92.7 62.7 59.5 34.1 85.9 96.8 145.4 62.7 59.5 91.4 33.2 154.1 92.7 62.7 59.6 34.1 85.9 96.8 145.4 62.7 59.6 91.4 33.2 154.1 92.8",
  fill: "none",
  stroke: "url(#bg0_svg__bK)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bL",
  gradientUnits: "userSpaceOnUse",
  x1: 1766.051,
  y1: 1191.459,
  x2: 2484.645,
  y2: 1191.459,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1013.6-332.2c63.1 59.2 91.7 32.8 154.8 91.9 63.1 59.2 34.5 85.6 97.7 144.8 63.1 59.2 91.7 32.8 154.8 91.9 63.1 59.2 34.5 85.6 97.7 144.8 63.1 59.2 91.7 32.8 154.8 91.9 63.1 59.2 34.6 85.6 97.7 144.8 63.1 59.2 91.7 32.8 154.8 91.9",
  fill: "none",
  stroke: "url(#bg0_svg__bL)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bM",
  gradientUnits: "userSpaceOnUse",
  x1: 1773.074,
  y1: 1187.391,
  x2: 2485.816,
  y2: 1187.391,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1006.2-325.8c63.6 58.8 92.1 32.3 155.6 91.1 63.6 58.8 35 85.3 98.6 144.1C1324-31.8 1352.5-58.3 1416 .5c63.6 58.8 35 85.3 98.6 144.1 63.6 58.8 92.1 32.3 155.6 91.1 63.6 58.8 35 85.3 98.6 144.1s92.1 32.3 155.6 91.1",
  fill: "none",
  stroke: "url(#bg0_svg__bM)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bN",
  gradientUnits: "userSpaceOnUse",
  x1: 1780.097,
  y1: 1183.323,
  x2: 2486.987,
  y2: 1183.323,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M998.9-319.4c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4c64 58.4 92.4 31.9 156.4 90.3",
  fill: "none",
  stroke: "url(#bg0_svg__bN)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bO",
  gradientUnits: "userSpaceOnUse",
  x1: 1787.12,
  y1: 1179.255,
  x2: 2488.158,
  y2: 1179.255,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M991.5-313c64.4 58 92.8 31.4 157.2 89.5 64.4 58 36 84.7 100.4 142.7 64.4 58 92.8 31.4 157.2 89.5 64.4 58 36 84.7 100.4 142.7 64.4 58 92.8 31.4 157.2 89.5 64.4 58 36 84.7 100.4 142.7 64.4 58 92.8 31.4 157.2 89.5",
  fill: "none",
  stroke: "url(#bg0_svg__bO)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bP",
  gradientUnits: "userSpaceOnUse",
  x1: 1794.143,
  y1: 1175.187,
  x2: 2489.329,
  y2: 1175.187,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M984.2-306.6c64.8 57.7 93.1 31 158 88.6 64.8 57.7 36.5 84.3 101.3 142s93.1 31 158 88.6c64.8 57.7 36.5 84.3 101.3 142s93.1 31 158 88.6c64.8 57.7 36.5 84.3 101.3 142s93.1 31 158 88.6",
  fill: "none",
  stroke: "url(#bg0_svg__bP)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bQ",
  gradientUnits: "userSpaceOnUse",
  x1: 1801.166,
  y1: 1171.119,
  x2: 2490.5,
  y2: 1171.119,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M976.9-300.2c65.2 57.3 93.5 30.5 158.7 87.8 65.2 57.3 37 84 102.2 141.3 65.2 57.3 93.5 30.5 158.7 87.8 65.2 57.3 37 84 102.2 141.3 65.2 57.3 93.5 30.5 158.7 87.8 65.2 57.3 37 84 102.2 141.3 65.2 57.3 93.5 30.5 158.7 87.8",
  fill: "none",
  stroke: "url(#bg0_svg__bQ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bR",
  gradientUnits: "userSpaceOnUse",
  x1: 1808.19,
  y1: 1167.051,
  x2: 2491.671,
  y2: 1167.051,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M969.5-293.8c65.7 56.9 93.8 30.1 159.5 87s37.5 83.7 103.1 140.6c65.7 56.9 93.8 30.1 159.5 87s37.5 83.7 103.1 140.6c65.7 56.9 93.8 30.1 159.5 87s37.5 83.7 103.1 140.6c65.7 56.9 93.9 30.1 159.5 87",
  fill: "none",
  stroke: "url(#bg0_svg__bR)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bS",
  gradientUnits: "userSpaceOnUse",
  x1: 1809.361,
  y1: 1162.982,
  x2: 2498.694,
  y2: 1162.982,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M968-292.8c65.2 57.3 93.5 30.5 158.7 87.8 65.2 57.3 37 84 102.2 141.3 65.2 57.3 93.5 30.5 158.7 87.8 65.2 57.3 37 84 102.2 141.3 65.2 57.3 93.5 30.5 158.7 87.8 65.2 57.3 37 84 102.2 141.3 65.2 57.3 93.5 30.5 158.7 87.8",
  fill: "none",
  stroke: "url(#bg0_svg__bS)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bT",
  gradientUnits: "userSpaceOnUse",
  x1: 1810.532,
  y1: 1158.914,
  x2: 2505.717,
  y2: 1158.914,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M966.5-291.7c64.8 57.7 93.1 31 158 88.6 64.8 57.7 36.5 84.3 101.3 142s93.1 31 158 88.6c64.8 57.7 36.5 84.3 101.3 142s93.1 31 158 88.6c64.8 57.7 36.5 84.3 101.3 142s93.1 31 158 88.6",
  fill: "none",
  stroke: "url(#bg0_svg__bT)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bU",
  gradientUnits: "userSpaceOnUse",
  x1: 1811.702,
  y1: 1154.846,
  x2: 2512.74,
  y2: 1154.846,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M965.1-290.7c64.4 58 92.8 31.4 157.2 89.5 64.4 58 36 84.7 100.4 142.7 64.4 58 92.8 31.4 157.2 89.5 64.4 58 36 84.7 100.4 142.7 64.4 58 92.8 31.4 157.2 89.5 64.4 58 36 84.7 100.4 142.7 64.4 58 92.8 31.4 157.2 89.5",
  fill: "none",
  stroke: "url(#bg0_svg__bU)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bV",
  gradientUnits: "userSpaceOnUse",
  x1: 1812.873,
  y1: 1150.778,
  x2: 2519.763,
  y2: 1150.778,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M963.6-289.6c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4c64 58.4 92.4 31.9 156.4 90.3",
  fill: "none",
  stroke: "url(#bg0_svg__bV)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bW",
  gradientUnits: "userSpaceOnUse",
  x1: 1814.045,
  y1: 1146.71,
  x2: 2526.786,
  y2: 1146.71,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M962.1-288.6c63.6 58.8 92.1 32.3 155.6 91.1 63.6 58.8 35 85.3 98.6 144.1 63.6 58.8 92.1 32.3 155.6 91.1 63.6 58.8 35 85.3 98.6 144.1 63.6 58.8 92.1 32.3 155.6 91.1 63.6 58.8 35 85.3 98.6 144.1 63.6 58.8 92.1 32.3 155.6 91.1",
  fill: "none",
  stroke: "url(#bg0_svg__bW)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bX",
  gradientUnits: "userSpaceOnUse",
  x1: 1815.216,
  y1: 1142.642,
  x2: 2533.809,
  y2: 1142.642,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M960.6-287.5c63.1 59.2 91.7 32.8 154.8 91.9 63.1 59.2 34.5 85.6 97.7 144.8 63.1 59.2 91.7 32.8 154.8 91.9 63.1 59.2 34.5 85.6 97.7 144.8 63.1 59.2 91.7 32.8 154.8 91.9 63.1 59.2 34.6 85.6 97.7 144.8 63.1 59.2 91.7 32.8 154.8 91.9",
  fill: "none",
  stroke: "url(#bg0_svg__bX)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bY",
  gradientUnits: "userSpaceOnUse",
  x1: 1816.387,
  y1: 1138.574,
  x2: 2540.832,
  y2: 1138.574,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M959.1-286.5c62.7 59.5 91.4 33.2 154.1 92.7 62.7 59.5 34.1 85.9 96.8 145.4 62.7 59.5 91.4 33.2 154.1 92.7 62.7 59.5 34.1 85.9 96.8 145.4 62.7 59.5 91.4 33.2 154.1 92.7 62.7 59.6 34.1 85.9 96.8 145.4 62.7 59.6 91.4 33.2 154.1 92.8",
  fill: "none",
  stroke: "url(#bg0_svg__bY)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__bZ",
  gradientUnits: "userSpaceOnUse",
  x1: 1817.557,
  y1: 1134.505,
  x2: 2547.856,
  y2: 1134.505,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M957.6-285.5c62.3 59.9 91 33.6 153.3 93.6 62.3 59.9 33.6 86.2 95.9 146.1 62.3 59.9 91 33.6 153.3 93.6 62.3 59.9 33.6 86.2 95.9 146.1 62.3 59.9 91 33.6 153.3 93.6 62.3 59.9 33.6 86.2 95.9 146.1 62.3 59.9 91 33.6 153.3 93.6",
  fill: "none",
  stroke: "url(#bg0_svg__bZ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ca",
  gradientUnits: "userSpaceOnUse",
  x1: 1818.729,
  y1: 1130.437,
  x2: 2554.878,
  y2: 1130.437,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M956.1-284.4c61.9 60.3 90.6 34.1 152.5 94.4 61.9 60.3 33.1 86.5 94.9 146.8 61.9 60.3 90.6 34.1 152.5 94.4 61.9 60.3 33.1 86.5 94.9 146.8 61.9 60.3 90.6 34.1 152.5 94.4 61.9 60.3 33.1 86.5 95 146.8 61.9 60.3 90.6 34.1 152.5 94.4",
  fill: "none",
  stroke: "url(#bg0_svg__ca)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cb",
  gradientUnits: "userSpaceOnUse",
  x1: 1819.899,
  y1: 1126.369,
  x2: 2561.902,
  y2: 1126.369,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M954.6-283.4c61.4 60.7 90.3 34.5 151.7 95.2 61.4 60.7 32.6 86.8 94 147.5s90.3 34.5 151.7 95.2c61.4 60.7 32.6 86.8 94 147.5s90.3 34.5 151.7 95.2c61.4 60.7 32.6 86.8 94 147.5s90.3 34.5 151.7 95.2",
  fill: "none",
  stroke: "url(#bg0_svg__cb)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cc",
  gradientUnits: "userSpaceOnUse",
  x1: 1821.071,
  y1: 1122.301,
  x2: 2568.925,
  y2: 1122.301,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M953.1-282.3c61 61.1 89.9 35 150.9 96 61 61.1 32.1 87.1 93.1 148.2 61 61.1 89.9 35 150.9 96 61 61.1 32.1 87.1 93.1 148.2 61 61.1 89.9 35 150.9 96 61 61.1 32.1 87.1 93.1 148.2 61 61.1 89.9 35 151 96",
  fill: "none",
  stroke: "url(#bg0_svg__cc)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cd",
  gradientUnits: "userSpaceOnUse",
  x1: 1822.242,
  y1: 1118.233,
  x2: 2575.948,
  y2: 1118.233,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M951.6-281.3c60.6 61.4 89.6 35.4 150.2 96.9 60.6 61.4 31.6 87.4 92.2 148.9 60.6 61.4 89.6 35.4 150.2 96.9 60.6 61.4 31.6 87.4 92.2 148.9 60.6 61.4 89.6 35.4 150.2 96.9 60.6 61.4 31.6 87.5 92.2 148.9 60.6 61.4 89.6 35.4 150.2 96.9",
  fill: "none",
  stroke: "url(#bg0_svg__cd)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ce",
  gradientUnits: "userSpaceOnUse",
  x1: 1823.413,
  y1: 1114.165,
  x2: 2582.97,
  y2: 1114.165,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M950.1-280.3c60.2 61.8 89.2 35.9 149.4 97.7 60.2 61.8 31.1 87.8 91.3 149.6 60.2 61.8 89.2 35.9 149.4 97.7 60.2 61.8 31.1 87.8 91.3 149.6 60.2 61.8 89.2 35.9 149.4 97.7 60.2 61.8 31.1 87.8 91.3 149.6 60.2 61.8 89.2 35.9 149.4 97.7",
  fill: "none",
  stroke: "url(#bg0_svg__ce)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cf",
  gradientUnits: "userSpaceOnUse",
  x1: 1824.584,
  y1: 1110.097,
  x2: 2589.993,
  y2: 1110.097,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M948.6-279.2c59.8 62.2 88.9 36.3 148.6 98.5 59.8 62.2 30.6 88.1 90.4 150.3 59.8 62.2 88.9 36.3 148.6 98.5 59.8 62.2 30.6 88.1 90.4 150.3 59.8 62.2 88.9 36.3 148.6 98.5 59.8 62.2 30.6 88.1 90.4 150.3 59.8 62.2 88.9 36.3 148.6 98.5",
  fill: "none",
  stroke: "url(#bg0_svg__cf)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cg",
  gradientUnits: "userSpaceOnUse",
  x1: 1825.755,
  y1: 1106.029,
  x2: 2597.016,
  y2: 1106.029,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M947.1-278.2c59.3 62.6 88.5 36.8 147.8 99.3 59.3 62.6 30.2 88.4 89.5 151 59.3 62.6 88.5 36.8 147.8 99.3 59.3 62.6 30.2 88.4 89.5 151 59.3 62.6 88.5 36.8 147.8 99.3 59.3 62.6 30.2 88.4 89.5 151s88.5 36.8 147.8 99.3",
  fill: "none",
  stroke: "url(#bg0_svg__cg)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ch",
  gradientUnits: "userSpaceOnUse",
  x1: 1826.927,
  y1: 1101.961,
  x2: 2604.039,
  y2: 1101.961,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M945.6-277.1c58.9 62.9 88.1 37.2 147.1 100.2 58.9 62.9 29.7 88.7 88.6 151.6 58.9 62.9 88.1 37.2 147.1 100.2 58.9 63 29.7 88.7 88.6 151.6 58.9 62.9 88.1 37.2 147.1 100.2 58.9 63 29.7 88.7 88.6 151.6 58.9 63 88.2 37.2 147.1 100.2",
  fill: "none",
  stroke: "url(#bg0_svg__ch)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ci",
  gradientUnits: "userSpaceOnUse",
  x1: 1828.098,
  y1: 1097.892,
  x2: 2611.062,
  y2: 1097.892,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M944.1-276.1c58.5 63.3 87.8 37.7 146.3 101 58.5 63.3 29.2 89 87.7 152.3 58.5 63.3 87.8 37.7 146.3 101 58.5 63.3 29.2 89 87.7 152.3 58.5 63.3 87.8 37.7 146.3 101 58.5 63.3 29.2 89 87.7 152.3s87.8 37.7 146.3 101",
  fill: "none",
  stroke: "url(#bg0_svg__ci)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cj",
  gradientUnits: "userSpaceOnUse",
  x1: 1829.269,
  y1: 1093.824,
  x2: 2618.085,
  y2: 1093.824,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M942.6-275.1c58.1 63.7 87.4 38.1 145.5 101.8 58.1 63.7 28.7 89.3 86.8 153 58.1 63.7 87.4 38.1 145.5 101.8 58.1 63.7 28.7 89.3 86.8 153 58.1 63.7 87.4 38.1 145.5 101.8 58.1 63.7 28.7 89.3 86.8 153 58.1 63.7 87.4 38.1 145.5 101.8",
  fill: "none",
  stroke: "url(#bg0_svg__cj)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ck",
  gradientUnits: "userSpaceOnUse",
  x1: 1830.44,
  y1: 1089.756,
  x2: 2625.108,
  y2: 1089.756,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M941.2-274c57.6 64.1 87.1 38.5 144.7 102.6 57.6 64.1 28.2 89.6 85.8 153.7 57.6 64.1 87.1 38.5 144.7 102.6 57.6 64.1 28.2 89.6 85.8 153.7 57.6 64.1 87.1 38.5 144.7 102.6 57.6 64.1 28.2 89.6 85.9 153.7 57.6 64.1 87.1 38.5 144.7 102.6",
  fill: "none",
  stroke: "url(#bg0_svg__ck)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cl",
  gradientUnits: "userSpaceOnUse",
  x1: 1831.611,
  y1: 1085.688,
  x2: 2632.131,
  y2: 1085.688,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M939.7-273c57.2 64.5 86.7 39 143.9 103.4 57.2 64.5 27.7 89.9 84.9 154.4s86.7 39 143.9 103.4c57.2 64.5 27.7 89.9 84.9 154.4s86.7 39 143.9 103.4c57.2 64.5 27.7 89.9 84.9 154.4s86.7 39 143.9 103.5",
  fill: "none",
  stroke: "url(#bg0_svg__cl)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cm",
  gradientUnits: "userSpaceOnUse",
  x1: 1832.783,
  y1: 1081.62,
  x2: 2639.154,
  y2: 1081.62,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M938.2-271.9c56.8 64.8 86.4 39.4 143.2 104.3 56.8 64.8 27.2 90.2 84 155.1 56.8 64.8 86.4 39.4 143.2 104.3 56.8 64.8 27.2 90.2 84 155.1 56.8 64.8 86.4 39.4 143.2 104.3 56.8 64.8 27.2 90.2 84 155.1 56.8 64.8 86.4 39.4 143.2 104.3",
  fill: "none",
  stroke: "url(#bg0_svg__cm)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cn",
  gradientUnits: "userSpaceOnUse",
  x1: 1833.954,
  y1: 1077.552,
  x2: 2646.177,
  y2: 1077.552,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M936.7-270.9c56.4 65.2 86 39.9 142.4 105.1 56.4 65.2 26.7 90.6 83.1 155.8 56.4 65.2 86 39.9 142.4 105.1 56.4 65.2 26.7 90.6 83.1 155.8 56.4 65.2 86 39.9 142.4 105.1 56.4 65.2 26.7 90.6 83.1 155.8 56.4 65.2 86 39.9 142.4 105.1",
  fill: "none",
  stroke: "url(#bg0_svg__cn)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__co",
  gradientUnits: "userSpaceOnUse",
  x1: 1835.125,
  y1: 1073.484,
  x2: 2653.199,
  y2: 1073.484,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M935.2-269.8c56 65.6 85.7 40.3 141.6 105.9 56 65.6 26.3 90.9 82.2 156.5 56 65.6 85.7 40.3 141.6 105.9 56 65.6 26.3 90.9 82.2 156.5 56 65.6 85.7 40.3 141.6 105.9 56 65.6 26.3 90.9 82.2 156.5 56 65.6 85.7 40.3 141.6 105.9",
  fill: "none",
  stroke: "url(#bg0_svg__co)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cp",
  gradientUnits: "userSpaceOnUse",
  x1: 1836.296,
  y1: 1069.416,
  x2: 2660.222,
  y2: 1069.416,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M933.7-268.8c55.5 66 85.3 40.8 140.8 106.7 55.5 66 25.8 91.2 81.3 157.1 55.5 66 85.3 40.8 140.8 106.7 55.5 66 25.8 91.2 81.3 157.2 55.5 66 85.3 40.8 140.8 106.7 55.5 66 25.8 91.2 81.3 157.2 55.5 66 85.3 40.8 140.8 106.7",
  fill: "none",
  stroke: "url(#bg0_svg__cp)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cq",
  gradientUnits: "userSpaceOnUse",
  x1: 1837.467,
  y1: 1065.348,
  x2: 2667.245,
  y2: 1065.348,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M932.2-267.8c55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6",
  fill: "none",
  stroke: "url(#bg0_svg__cq)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cr",
  gradientUnits: "userSpaceOnUse",
  x1: 1838.579,
  y1: 1061.436,
  x2: 2674.013,
  y2: 1061.436,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M931.1-266.7c54.7 66.7 84.5 41.7 139.2 108.4 54.7 66.7 24.8 91.8 79.4 158.5 54.7 66.7 84.5 41.7 139.2 108.4 54.7 66.7 24.8 91.8 79.4 158.5 54.7 66.7 84.5 41.7 139.2 108.4 54.7 66.7 24.8 91.8 79.4 158.5 54.7 66.7 84.5 41.7 139.2 108.4",
  fill: "none",
  stroke: "url(#bg0_svg__cr)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cs",
  gradientUnits: "userSpaceOnUse",
  x1: 1839.69,
  y1: 1057.524,
  x2: 2680.78,
  y2: 1057.524,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M930-265.7c54.2 67.1 84.1 42.1 138.3 109.2 54.2 67.1 24.3 92 78.5 159.1s84.1 42.1 138.3 109.2c54.2 67.1 24.3 92.1 78.5 159.1 54.2 67.1 84.1 42.1 138.3 109.2 54.2 67.1 24.3 92.1 78.5 159.1 54.2 67.1 84.1 42.1 138.3 109.2",
  fill: "none",
  stroke: "url(#bg0_svg__cs)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ct",
  gradientUnits: "userSpaceOnUse",
  x1: 1840.801,
  y1: 1053.612,
  x2: 2687.548,
  y2: 1053.612,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M929-264.7c53.7 67.4 83.7 42.5 137.5 110 53.7 67.4 23.7 92.3 77.5 159.8 53.7 67.4 83.7 42.5 137.5 110 53.7 67.4 23.7 92.3 77.5 159.8 53.7 67.4 83.7 42.5 137.5 110 53.7 67.4 23.7 92.3 77.5 159.8 53.7 67.4 83.7 42.5 137.5 110",
  fill: "none",
  stroke: "url(#bg0_svg__ct)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cu",
  gradientUnits: "userSpaceOnUse",
  x1: 1841.912,
  y1: 1049.701,
  x2: 2694.316,
  y2: 1049.701,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M927.9-263.7c53.3 67.8 83.3 43 136.6 110.8s23.2 92.6 76.5 160.4c53.3 67.8 83.3 43 136.6 110.8s23.2 92.6 76.5 160.4c53.3 67.8 83.3 43 136.6 110.8s23.2 92.6 76.5 160.4c53.3 67.8 83.3 43 136.6 110.8",
  fill: "none",
  stroke: "url(#bg0_svg__cu)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cv",
  gradientUnits: "userSpaceOnUse",
  x1: 1843.023,
  y1: 1045.789,
  x2: 2701.084,
  y2: 1045.789,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M926.8-262.7c52.8 68.2 82.9 43.4 135.8 111.6 52.8 68.2 22.7 92.9 75.5 161 52.8 68.2 82.9 43.4 135.8 111.6 52.8 68.2 22.7 92.9 75.6 161 52.8 68.2 82.9 43.4 135.8 111.6 52.8 68.2 22.7 92.9 75.6 161 52.8 68.2 82.9 43.4 135.8 111.6",
  fill: "none",
  stroke: "url(#bg0_svg__cv)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cw",
  gradientUnits: "userSpaceOnUse",
  x1: 1844.134,
  y1: 1041.878,
  x2: 2707.852,
  y2: 1041.878,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M925.7-261.7c52.4 68.5 82.5 43.9 134.9 112.4 52.4 68.5 22.2 93.2 74.6 161.7 52.4 68.5 82.5 43.9 134.9 112.4 52.4 68.5 22.2 93.2 74.6 161.7 52.4 68.5 82.5 43.9 134.9 112.4 52.4 68.5 22.2 93.2 74.6 161.7 52.4 68.5 82.5 43.9 134.9 112.4",
  fill: "none",
  stroke: "url(#bg0_svg__cw)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cx",
  gradientUnits: "userSpaceOnUse",
  x1: 1845.246,
  y1: 1037.966,
  x2: 2714.619,
  y2: 1037.966,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M924.6-260.6c51.9 68.9 82.1 44.3 134.1 113.2 51.9 68.9 21.7 93.5 73.6 162.3 51.9 68.9 82.1 44.3 134.1 113.2 51.9 68.9 21.7 93.5 73.6 162.3 51.9 68.9 82.1 44.3 134.1 113.2 51.9 68.9 21.7 93.5 73.6 162.3 51.9 68.9 82.1 44.3 134.1 113.2",
  fill: "none",
  stroke: "url(#bg0_svg__cx)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cy",
  gradientUnits: "userSpaceOnUse",
  x1: 1846.357,
  y1: 1034.054,
  x2: 2721.387,
  y2: 1034.054,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M923.6-259.6c51.5 69.2 81.7 44.7 133.2 114 51.5 69.2 21.2 93.7 72.6 163 51.5 69.2 81.7 44.7 133.2 114 51.5 69.2 21.2 93.7 72.6 163 51.5 69.2 81.7 44.7 133.2 114 51.5 69.2 21.2 93.7 72.7 163s81.7 44.7 133.2 114",
  fill: "none",
  stroke: "url(#bg0_svg__cy)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cz",
  gradientUnits: "userSpaceOnUse",
  x1: 1847.468,
  y1: 1030.143,
  x2: 2728.155,
  y2: 1030.143,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M922.5-258.6c51 69.6 81.3 45.2 132.3 114.8 51 69.6 20.7 94 71.7 163.6s81.3 45.2 132.3 114.8c51 69.6 20.7 94 71.7 163.6s81.3 45.2 132.3 114.8c51 69.6 20.7 94 71.7 163.6s81.3 45.2 132.3 114.8",
  fill: "none",
  stroke: "url(#bg0_svg__cz)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cA",
  gradientUnits: "userSpaceOnUse",
  x1: 1848.579,
  y1: 1026.231,
  x2: 2734.922,
  y2: 1026.231,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M921.4-257.6c50.5 70 80.9 45.6 131.5 115.6 50.5 70 20.2 94.3 70.7 164.2 50.5 70 80.9 45.6 131.5 115.6 50.5 70 20.2 94.3 70.7 164.2 50.5 70 80.9 45.6 131.5 115.6 50.6 70 20.2 94.3 70.7 164.3s80.9 45.6 131.5 115.6",
  fill: "none",
  stroke: "url(#bg0_svg__cA)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cB",
  gradientUnits: "userSpaceOnUse",
  x1: 1849.69,
  y1: 1022.319,
  x2: 2741.69,
  y2: 1022.319,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M920.3-256.6c50.1 70.3 80.5 46 130.6 116.4 50.1 70.3 19.7 94.6 69.7 164.9 50.1 70.3 80.5 46 130.6 116.4 50.1 70.3 19.7 94.6 69.7 164.9 50.1 70.3 80.5 46 130.6 116.4 50.1 70.3 19.7 94.6 69.8 164.9 50.1 70.3 80.5 46.1 130.6 116.4",
  fill: "none",
  stroke: "url(#bg0_svg__cB)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cC",
  gradientUnits: "userSpaceOnUse",
  x1: 1850.802,
  y1: 1018.408,
  x2: 2748.457,
  y2: 1018.408,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M919.2-255.6c49.6 70.7 80.1 46.5 129.8 117.2 49.6 70.7 19.1 94.9 68.8 165.5 49.6 70.7 80.1 46.5 129.8 117.2 49.6 70.7 19.1 94.9 68.8 165.5 49.6 70.7 80.1 46.5 129.8 117.2 49.6 70.7 19.1 94.9 68.8 165.5 49.6 70.7 80.1 46.5 129.8 117.2",
  fill: "none",
  stroke: "url(#bg0_svg__cC)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cD",
  gradientUnits: "userSpaceOnUse",
  x1: 1851.913,
  y1: 1014.496,
  x2: 2755.225,
  y2: 1014.496,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M918.2-254.5c49.2 71 79.7 46.9 128.9 118 49.2 71 18.6 95.1 67.8 166.2 49.2 71 79.7 46.9 128.9 118 49.2 71 18.6 95.1 67.8 166.2 49.2 71 79.7 46.9 128.9 118 49.2 71 18.6 95.1 67.8 166.2s79.7 46.9 128.9 118",
  fill: "none",
  stroke: "url(#bg0_svg__cD)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cE",
  gradientUnits: "userSpaceOnUse",
  x1: 1853.024,
  y1: 1010.585,
  x2: 2761.993,
  y2: 1010.585,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M917.1-253.5c48.7 71.4 79.3 47.4 128 118.8s18.1 95.4 66.8 166.8c48.7 71.4 79.3 47.4 128 118.8s18.1 95.4 66.8 166.8c48.7 71.4 79.3 47.4 128 118.8s18.1 95.4 66.8 166.8c48.7 71.4 79.3 47.4 128.1 118.8",
  fill: "none",
  stroke: "url(#bg0_svg__cE)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cF",
  gradientUnits: "userSpaceOnUse",
  x1: 1854.136,
  y1: 1006.673,
  x2: 2768.761,
  y2: 1006.673,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M916-252.5c48.3 71.8 78.9 47.8 127.2 119.6s17.6 95.7 65.9 167.4c48.3 71.8 78.9 47.8 127.2 119.6s17.6 95.7 65.9 167.4c48.3 71.8 78.9 47.8 127.2 119.6s17.6 95.7 65.9 167.5 78.9 47.8 127.2 119.6",
  fill: "none",
  stroke: "url(#bg0_svg__cF)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cG",
  gradientUnits: "userSpaceOnUse",
  x1: 1855.247,
  y1: 1002.761,
  x2: 2775.528,
  y2: 1002.761,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M914.9-251.5c47.8 72.1 78.5 48.2 126.3 120.4 47.8 72.1 17.1 96 64.9 168.1 47.8 72.1 78.5 48.2 126.3 120.4 47.8 72.1 17.1 96 64.9 168.1 47.8 72.1 78.5 48.2 126.3 120.4 47.8 72.1 17.1 96 64.9 168.1 47.8 72.1 78.5 48.2 126.3 120.4",
  fill: "none",
  stroke: "url(#bg0_svg__cG)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cH",
  gradientUnits: "userSpaceOnUse",
  x1: 1856.358,
  y1: 998.85,
  x2: 2782.296,
  y2: 998.85,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M913.8-250.5c47.4 72.5 78.1 48.7 125.5 121.2 47.4 72.5 16.6 96.3 63.9 168.7 47.4 72.5 78.1 48.7 125.5 121.2 47.4 72.5 16.6 96.3 63.9 168.7 47.4 72.5 78.1 48.7 125.5 121.2 47.4 72.5 16.6 96.3 63.9 168.7 47.4 72.5 78.1 48.7 125.5 121.2",
  fill: "none",
  stroke: "url(#bg0_svg__cH)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cI",
  gradientUnits: "userSpaceOnUse",
  x1: 1857.469,
  y1: 994.938,
  x2: 2789.064,
  y2: 994.938,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M912.8-249.4c46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 63 169.4 46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 63 169.4 46.9 72.8 77.7 49.1 124.6 122 46.9 72.8 16.1 96.5 63 169.4 46.9 72.8 77.7 49.1 124.6 122",
  fill: "none",
  stroke: "url(#bg0_svg__cI)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cJ",
  gradientUnits: "userSpaceOnUse",
  x1: 1858.581,
  y1: 991.026,
  x2: 2795.831,
  y2: 991.026,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M911.7-248.4c46.4 73.2 77.3 49.6 123.8 122.8 46.4 73.2 15.6 96.8 62 170s77.3 49.6 123.8 122.8c46.4 73.2 15.6 96.8 62 170s77.3 49.6 123.8 122.8c46.4 73.2 15.6 96.8 62 170s77.3 49.6 123.8 122.8",
  fill: "none",
  stroke: "url(#bg0_svg__cJ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cK",
  gradientUnits: "userSpaceOnUse",
  x1: 1859.692,
  y1: 987.115,
  x2: 2802.599,
  y2: 987.115,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M910.6-247.4c46 73.6 76.9 50 122.9 123.6s15.1 97.1 61 170.6c46 73.6 76.9 50 122.9 123.6s15.1 97.1 61 170.7c46 73.6 76.9 50 122.9 123.6s15.1 97.1 61 170.7 76.9 50 122.9 123.6",
  fill: "none",
  stroke: "url(#bg0_svg__cK)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cL",
  gradientUnits: "userSpaceOnUse",
  x1: 1860.803,
  y1: 983.203,
  x2: 2809.367,
  y2: 983.203,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M909.5-246.4C955-172.5 986-196 1031.5-122c45.5 73.9 14.5 97.4 60.1 171.3 45.5 73.9 76.5 50.4 122 124.4 45.5 73.9 14.5 97.4 60.1 171.3 45.5 73.9 76.5 50.4 122 124.4 45.5 73.9 14.5 97.4 60.1 171.3 45.5 73.9 76.5 50.4 122.1 124.4",
  fill: "none",
  stroke: "url(#bg0_svg__cL)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cM",
  gradientUnits: "userSpaceOnUse",
  x1: 1861.915,
  y1: 979.291,
  x2: 2816.134,
  y2: 979.291,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M908.4-245.4c45.1 74.3 76.1 50.9 121.2 125.2 45.1 74.3 14 97.7 59.1 171.9 45.1 74.3 76.1 50.9 121.2 125.2 45.1 74.3 14 97.7 59.1 171.9 45.1 74.3 76.1 50.9 121.2 125.2 45.1 74.3 14 97.7 59.1 171.9 45.1 74.3 76.1 50.9 121.2 125.2",
  fill: "none",
  stroke: "url(#bg0_svg__cM)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cN",
  gradientUnits: "userSpaceOnUse",
  x1: 1863.026,
  y1: 975.38,
  x2: 2822.902,
  y2: 975.38,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M907.4-244.4c44.6 74.6 75.7 51.3 120.3 126 44.6 74.6 13.5 97.9 58.1 172.6 44.6 74.6 75.7 51.3 120.3 126 44.6 74.6 13.5 97.9 58.1 172.6 44.6 74.6 75.7 51.3 120.3 126 44.6 74.6 13.5 97.9 58.1 172.6s75.7 51.3 120.3 126",
  fill: "none",
  stroke: "url(#bg0_svg__cN)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cO",
  gradientUnits: "userSpaceOnUse",
  x1: 1864.137,
  y1: 971.468,
  x2: 2829.669,
  y2: 971.468,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M906.3-243.3c44.2 75 75.3 51.8 119.5 126.8s13 98.2 57.2 173.2c44.2 75 75.3 51.8 119.5 126.8s13 98.2 57.2 173.2c44.2 75 75.3 51.8 119.5 126.8s13 98.2 57.2 173.2c44.2 75 75.3 51.8 119.5 126.8",
  fill: "none",
  stroke: "url(#bg0_svg__cO)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cP",
  gradientUnits: "userSpaceOnUse",
  x1: 1865.249,
  y1: 967.556,
  x2: 2836.437,
  y2: 967.556,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M905.2-242.3c43.7 75.4 74.9 52.2 118.6 127.6 43.7 75.4 12.5 98.5 56.2 173.9s74.9 52.2 118.6 127.6c43.7 75.4 12.5 98.5 56.2 173.9s74.9 52.2 118.6 127.6c43.7 75.4 12.5 98.5 56.2 173.9s74.9 52.2 118.6 127.6",
  fill: "none",
  stroke: "url(#bg0_svg__cP)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cQ",
  gradientUnits: "userSpaceOnUse",
  x1: 1866.36,
  y1: 963.645,
  x2: 2843.204,
  y2: 963.645,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M904.1-241.3c43.2 75.7 74.5 52.6 117.8 128.4 43.2 75.7 12 98.8 55.2 174.5s74.5 52.6 117.8 128.4c43.2 75.7 12 98.8 55.2 174.5s74.5 52.6 117.8 128.4c43.3 75.7 12 98.8 55.2 174.5s74.5 52.6 117.8 128.4",
  fill: "none",
  stroke: "url(#bg0_svg__cQ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cR",
  gradientUnits: "userSpaceOnUse",
  x1: 1873.288,
  y1: 959.94,
  x2: 2843.738,
  y2: 959.94,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M896.5-235c43.8 75.3 75 52.1 118.7 127.4 43.8 75.3 12.6 98.5 56.3 173.8 43.8 75.3 75 52.1 118.7 127.4 43.8 75.3 12.6 98.5 56.3 173.8 43.8 75.3 75 52.1 118.7 127.4 43.8 75.3 12.6 98.5 56.3 173.8 43.8 75.3 75 52.1 118.7 127.5",
  fill: "none",
  stroke: "url(#bg0_svg__cR)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cS",
  gradientUnits: "userSpaceOnUse",
  x1: 1880.216,
  y1: 956.235,
  x2: 2844.273,
  y2: 956.235,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M888.9-228.7c44.3 74.9 75.4 51.6 119.7 126.5s13.1 98.1 57.4 173 75.4 51.6 119.7 126.5 13.1 98.1 57.4 173 75.4 51.6 119.7 126.5 13.1 98.2 57.4 173.1c44.3 74.9 75.4 51.6 119.7 126.6",
  fill: "none",
  stroke: "url(#bg0_svg__cS)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cT",
  gradientUnits: "userSpaceOnUse",
  x1: 1887.145,
  y1: 952.53,
  x2: 2844.807,
  y2: 952.53,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M881.3-222.5c44.8 74.5 75.9 51.1 120.7 125.6s13.7 97.8 58.5 172.3c44.8 74.5 75.9 51.1 120.7 125.6s13.7 97.8 58.5 172.3c44.8 74.5 75.9 51.1 120.7 125.6s13.7 97.8 58.5 172.3 75.9 51.2 120.7 125.6",
  fill: "none",
  stroke: "url(#bg0_svg__cT)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cU",
  gradientUnits: "userSpaceOnUse",
  x1: 1894.073,
  y1: 948.825,
  x2: 2845.341,
  y2: 948.825,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M873.7-216.2C919-142.1 950-165.5 995.3-91.5c45.3 74.1 14.3 97.5 59.6 171.6s76.3 50.7 121.6 124.7c45.3 74.1 14.3 97.5 59.6 171.6s76.3 50.7 121.6 124.7c45.3 74.1 14.3 97.5 59.6 171.6s76.3 50.7 121.6 124.7",
  fill: "none",
  stroke: "url(#bg0_svg__cU)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cV",
  gradientUnits: "userSpaceOnUse",
  x1: 1901.001,
  y1: 945.121,
  x2: 2845.875,
  y2: 945.121,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M866.1-209.9c45.8 73.7 76.8 50.2 122.6 123.8 45.8 73.7 14.9 97.2 60.7 170.9 45.8 73.7 76.8 50.2 122.6 123.8 45.8 73.7 14.9 97.2 60.7 170.9 45.8 73.7 76.8 50.2 122.6 123.8 45.8 73.7 14.9 97.2 60.7 170.9 45.8 73.7 76.8 50.2 122.6 123.8",
  fill: "none",
  stroke: "url(#bg0_svg__cV)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cW",
  gradientUnits: "userSpaceOnUse",
  x1: 1907.929,
  y1: 941.416,
  x2: 2846.409,
  y2: 941.416,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M858.5-203.6c46.3 73.3 77.2 49.7 123.6 122.9 46.3 73.3 15.5 96.9 61.8 170.1 46.3 73.3 77.2 49.7 123.6 122.9 46.3 73.3 15.5 96.9 61.8 170.2 46.3 73.3 77.2 49.7 123.6 122.9 46.3 73.3 15.5 96.9 61.8 170.2 46.3 73.3 77.2 49.7 123.6 122.9",
  fill: "none",
  stroke: "url(#bg0_svg__cW)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cX",
  gradientUnits: "userSpaceOnUse",
  x1: 1914.857,
  y1: 937.711,
  x2: 2846.943,
  y2: 937.711,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M850.9-197.3c46.9 72.9 77.7 49.2 124.5 122 46.9 72.9 16 96.6 62.9 169.4 46.9 72.9 77.7 49.2 124.5 122 46.9 72.9 16 96.6 62.9 169.4 46.9 72.9 77.7 49.2 124.5 122 46.9 72.9 16 96.6 62.9 169.4 46.9 72.9 77.7 49.2 124.5 122",
  fill: "none",
  stroke: "url(#bg0_svg__cX)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cY",
  gradientUnits: "userSpaceOnUse",
  x1: 1921.785,
  y1: 934.006,
  x2: 2847.477,
  y2: 934.006,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M843.3-191.1c47.4 72.5 78.1 48.7 125.5 121.1 47.4 72.5 16.6 96.2 64 168.7 47.4 72.5 78.1 48.7 125.5 121.1 47.4 72.5 16.6 96.2 64 168.7 47.4 72.5 78.1 48.7 125.5 121.1 47.4 72.5 16.6 96.2 64 168.7 47.4 72.5 78.1 48.7 125.5 121.1",
  fill: "none",
  stroke: "url(#bg0_svg__cY)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__cZ",
  gradientUnits: "userSpaceOnUse",
  x1: 1928.714,
  y1: 930.301,
  x2: 2848.012,
  y2: 930.301,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M835.7-184.8c47.9 72 78.6 48.2 126.5 120.2 47.9 72 17.2 95.9 65.1 168 47.9 72 78.6 48.2 126.5 120.2 47.9 72 17.2 95.9 65.1 168 47.9 72 78.6 48.2 126.5 120.2 47.9 72.1 17.2 95.9 65.1 168 47.9 72.1 78.6 48.2 126.5 120.2",
  fill: "none",
  stroke: "url(#bg0_svg__cZ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__da",
  gradientUnits: "userSpaceOnUse",
  x1: 1935.642,
  y1: 926.597,
  x2: 2848.545,
  y2: 926.597,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M828.1-178.5c48.4 71.6 79 47.7 127.5 119.3 48.4 71.6 17.8 95.6 66.2 167.3 48.4 71.6 79 47.7 127.5 119.3 48.4 71.6 17.8 95.6 66.2 167.3 48.4 71.6 79 47.7 127.5 119.3 48.4 71.6 17.8 95.6 66.2 167.3s79 47.7 127.5 119.3",
  fill: "none",
  stroke: "url(#bg0_svg__da)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__db",
  gradientUnits: "userSpaceOnUse",
  x1: 1942.57,
  y1: 922.892,
  x2: 2849.08,
  y2: 922.892,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M820.5-172.2C869.5-101 900-125 949-53.8c48.9 71.2 18.3 95.3 67.3 166.5 48.9 71.2 79.5 47.2 128.4 118.4 48.9 71.2 18.3 95.3 67.3 166.5 48.9 71.2 79.5 47.2 128.4 118.4 48.9 71.2 18.3 95.3 67.3 166.5 48.9 71.2 79.5 47.2 128.4 118.4",
  fill: "none",
  stroke: "url(#bg0_svg__db)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dc",
  gradientUnits: "userSpaceOnUse",
  x1: 1949.498,
  y1: 919.187,
  x2: 2849.613,
  y2: 919.187,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M812.9-165.9c49.4 70.8 80 46.7 129.4 117.5 49.4 70.8 18.9 95 68.4 165.8 49.4 70.8 80 46.7 129.4 117.5 49.4 70.8 18.9 95 68.4 165.8 49.4 70.8 80 46.7 129.4 117.5 49.4 70.8 18.9 95 68.4 165.8 49.4 70.8 80 46.7 129.4 117.5",
  fill: "none",
  stroke: "url(#bg0_svg__dc)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dd",
  gradientUnits: "userSpaceOnUse",
  x1: 1956.427,
  y1: 915.482,
  x2: 2850.148,
  y2: 915.482,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M805.3-159.6c50 70.4 80.4 46.2 130.4 116.6 50 70.4 19.5 94.7 69.4 165.1 50 70.4 80.4 46.2 130.4 116.6 50 70.4 19.5 94.7 69.5 165.1 50 70.4 80.4 46.2 130.4 116.6 50 70.4 19.5 94.7 69.5 165.1 50 70.4 80.4 46.2 130.4 116.6",
  fill: "none",
  stroke: "url(#bg0_svg__dd)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__de",
  gradientUnits: "userSpaceOnUse",
  x1: 1963.355,
  y1: 911.777,
  x2: 2850.682,
  y2: 911.777,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M797.7-153.4c50.5 70 80.9 45.7 131.3 115.7 50.5 70 20.1 94.3 70.5 164.4 50.5 70 80.9 45.7 131.3 115.7 50.5 70 20.1 94.3 70.5 164.4 50.5 70 80.9 45.7 131.3 115.7 50.5 70 20.1 94.3 70.5 164.4 50.5 70 80.9 45.7 131.3 115.7",
  fill: "none",
  stroke: "url(#bg0_svg__de)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__df",
  gradientUnits: "userSpaceOnUse",
  x1: 1970.283,
  y1: 908.072,
  x2: 2851.216,
  y2: 908.072,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M790.1-147.1c51 69.6 81.3 45.2 132.3 114.8 51 69.6 20.7 94 71.6 163.6 51 69.6 81.3 45.2 132.3 114.8 51 69.6 20.7 94 71.6 163.6 51 69.6 81.3 45.2 132.3 114.8 51 69.6 20.7 94 71.6 163.6s81.3 45.2 132.3 114.8",
  fill: "none",
  stroke: "url(#bg0_svg__df)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dg",
  gradientUnits: "userSpaceOnUse",
  x1: 1977.211,
  y1: 904.368,
  x2: 2851.749,
  y2: 904.368,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M782.5-140.8C834-71.6 864.3-96.1 915.8-26.9 967.3 42.3 937 66.8 988.5 136s81.8 44.7 133.3 113.9c51.5 69.2 21.2 93.7 72.7 162.9s81.8 44.7 133.3 113.9c51.5 69.2 21.2 93.7 72.7 162.9s81.8 44.7 133.3 113.9",
  fill: "none",
  stroke: "url(#bg0_svg__dg)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dh",
  gradientUnits: "userSpaceOnUse",
  x1: 1984.14,
  y1: 900.663,
  x2: 2852.283,
  y2: 900.663,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M774.9-134.5c52 68.8 82.2 44.2 134.2 113 52 68.8 21.8 93.4 73.8 162.2 52 68.8 82.2 44.2 134.2 113 52 68.8 21.8 93.4 73.8 162.2 52 68.8 82.2 44.2 134.2 113 52 68.8 21.8 93.4 73.8 162.2 52 68.8 82.2 44.2 134.2 113",
  fill: "none",
  stroke: "url(#bg0_svg__dh)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__di",
  gradientUnits: "userSpaceOnUse",
  x1: 1991.068,
  y1: 896.958,
  x2: 2852.818,
  y2: 896.958,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M767.3-128.2c52.6 68.3 82.7 43.7 135.2 112 52.5 68.4 22.4 93.1 74.9 161.5 52.5 68.4 82.7 43.7 135.2 112.1 52.5 68.4 22.4 93.1 74.9 161.5 52.5 68.4 82.7 43.7 135.2 112.1 52.5 68.4 22.4 93.1 74.9 161.5 52.5 68.4 82.7 43.7 135.2 112.1",
  fill: "none",
  stroke: "url(#bg0_svg__di)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dj",
  gradientUnits: "userSpaceOnUse",
  x1: 1997.996,
  y1: 893.253,
  x2: 2853.352,
  y2: 893.253,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M759.7-122c53 68 83.1 43.2 136.2 111.2 53 68 23 92.8 76 160.7 53 68 83.1 43.2 136.2 111.2 53 68 23 92.8 76 160.7 53 68 83.1 43.2 136.2 111.2 53 68 23 92.8 76 160.7 53 68 83.1 43.2 136.2 111.2",
  fill: "none",
  stroke: "url(#bg0_svg__dj)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dk",
  gradientUnits: "userSpaceOnUse",
  x1: 2004.925,
  y1: 889.548,
  x2: 2853.885,
  y2: 889.548,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M752.1-115.7C805.7-48.1 835.7-73 889.3-5.4c53.6 67.6 23.5 92.4 77.1 160 53.6 67.6 83.6 42.7 137.1 110.3 53.6 67.6 23.5 92.4 77.1 160 53.6 67.6 83.6 42.7 137.1 110.3 53.6 67.6 23.5 92.4 77.1 160 53.6 67.6 83.6 42.7 137.1 110.3",
  fill: "none",
  stroke: "url(#bg0_svg__dk)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dl",
  gradientUnits: "userSpaceOnUse",
  x1: 2011.853,
  y1: 885.844,
  x2: 2854.419,
  y2: 885.844,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M744.5-109.4c54.1 67.2 84 42.2 138.1 109.4 54.1 67.2 24.1 92.1 78.2 159.3 54.1 67.2 84 42.2 138.1 109.4 54.1 67.2 24.1 92.1 78.2 159.3 54.1 67.2 84 42.2 138.1 109.4 54.1 67.2 24.1 92.1 78.2 159.3 54.1 67.2 84 42.2 138.1 109.4",
  fill: "none",
  stroke: "url(#bg0_svg__dl)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dm",
  gradientUnits: "userSpaceOnUse",
  x1: 2018.781,
  y1: 882.139,
  x2: 2854.953,
  y2: 882.139,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M736.9-103.1C791.5-36.4 821.4-61.4 876 5.4c54.6 66.8 24.7 91.8 79.3 158.6 54.6 66.8 84.5 41.7 139.1 108.5 54.6 66.8 24.7 91.8 79.3 158.6 54.6 66.8 84.5 41.7 139.1 108.5 54.6 66.8 24.7 91.8 79.3 158.6s84.5 41.7 139.1 108.5",
  fill: "none",
  stroke: "url(#bg0_svg__dm)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dn",
  gradientUnits: "userSpaceOnUse",
  x1: 2025.71,
  y1: 878.434,
  x2: 2855.487,
  y2: 878.434,
  gradientTransform: "matrix(-.08862 .9961 .9961 .08862 471.338 -2153.778)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.259,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("path", {
  d: "M729.3-96.8c55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6 55.1 66.4 25.3 91.5 80.4 157.8 55.1 66.4 84.9 41.2 140.1 107.6",
  fill: "none",
  stroke: "url(#bg0_svg__dn)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg0_svg__do",
  d: "M910 948.2h542.2v1767.1H910z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bg0_svg__dp"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg0_svg__do",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg0_svg__dp)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dq",
  gradientUnits: "userSpaceOnUse",
  x1: 1419.72,
  y1: 717.036,
  x2: 1419.72,
  y2: 2749.012,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1523.1 1467.3c-26.5 98.2-266.2 175-242.7 417 17.3 178.1-152.8 273.4-63.3 514.8 52.7 142 156.7 180.9 84.8 323-168.7 333.3 78.4 772 78.4 772",
  fill: "none",
  stroke: "url(#bg0_svg__dq)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dr",
  gradientUnits: "userSpaceOnUse",
  x1: 1427.995,
  y1: 717.037,
  x2: 1427.995,
  y2: 2749.013,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 1467.8c-25.9 96.3-257.3 175.1-240.9 413.5 12.3 178.3-152.7 276.9-63.6 518.4 53.9 146.8 150.8 188.9 80.1 333.6-162.4 332.1 79.5 761 79.5 761",
  fill: "none",
  stroke: "url(#bg0_svg__dr)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__ds",
  gradientUnits: "userSpaceOnUse",
  x1: 1436.171,
  y1: 717.038,
  x2: 1436.171,
  y2: 2749.013,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1538.5 1468.3c-25 94.5-248.6 175.5-238.9 410.2 7.4 178.4-152.7 280.2-63.8 522.1 55.2 151.3 144.9 196.8 75.4 344.1-156 330.9 80.6 749.9 80.6 749.9",
  fill: "none",
  stroke: "url(#bg0_svg__ds)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dt",
  gradientUnits: "userSpaceOnUse",
  x1: 1444.598,
  y1: 716.916,
  x2: 1444.598,
  y2: 2749.013,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1546.3 1468.7c-24.2 92.4-239.9 175.9-237 406.8 2.3 179-152.5 283.7-64.1 525.9 56.3 156.1 138.9 204.7 70.6 354.8-150 329.6 81.5 738.9 81.5 738.9",
  fill: "none",
  stroke: "url(#bg0_svg__dt)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__du",
  gradientUnits: "userSpaceOnUse",
  x1: 1452.997,
  y1: 717.162,
  x2: 1452.997,
  y2: 2749.013,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1554.2 1469.5c-23.6 90.5-231.5 176.3-235.1 403.3-2.9 179.5-152 286.8-64.4 529.6 57.9 160.5 133.1 212.5 66 365.3-143.9 328 82.6 727.8 82.6 727.8",
  fill: "none",
  stroke: "url(#bg0_svg__du)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dv",
  gradientUnits: "userSpaceOnUse",
  x1: 1461.266,
  y1: 717.041,
  x2: 1461.266,
  y2: 2749.014,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1561.9 1469.9c-22.9 88.7-223.2 177-233.2 400-8.1 180-151.8 290.1-64.7 533.3 59.2 165.1 127 220.4 61.2 376-138.1 326.5 83.6 716.7 83.6 716.7",
  fill: "none",
  stroke: "url(#bg0_svg__dv)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dw",
  gradientUnits: "userSpaceOnUse",
  x1: 1469.397,
  y1: 717.042,
  x2: 1469.397,
  y2: 2749.014,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1569.5 1470.4c-22.1 86.6-215 177.6-231.2 396.5-13.3 180.6-151.7 293.5-64.9 537 60.5 169.8 121.1 228.1 56.6 386.6-132.2 325 84.7 705.7 84.7 705.7",
  fill: "none",
  stroke: "url(#bg0_svg__dw)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dx",
  gradientUnits: "userSpaceOnUse",
  x1: 1477.626,
  y1: 717.165,
  x2: 1477.626,
  y2: 2749.015,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1577.3 1471c-21.5 84.7-207.1 178.3-229.4 393.1-18.8 181.4-151.7 296.9-65.3 540.6 61.8 174.3 115.1 235.9 51.9 397.2-126.5 323.2 85.8 694.7 85.8 694.7",
  fill: "none",
  stroke: "url(#bg0_svg__dx)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dy",
  gradientUnits: "userSpaceOnUse",
  x1: 1485.949,
  y1: 717.043,
  x2: 1485.949,
  y2: 2749.015,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1585.2 1471.4c-20.8 82.9-199.3 179.2-227.4 389.8-24.3 182.1-151.5 300.3-65.5 544.3 62.9 178.9 108.9 243.6 47.2 407.8-121 321.5 86.8 683.7 86.8 683.7",
  fill: "none",
  stroke: "url(#bg0_svg__dy)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dz",
  gradientUnits: "userSpaceOnUse",
  x1: 1493.872,
  y1: 717.168,
  x2: 1493.872,
  y2: 2749.016,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1592.7 1472c-19.9 80.9-191.7 179.9-225.5 386.3-29.9 182.9-151.4 303.6-65.8 548 64.2 183.4 102.9 251.2 42.5 418.4-115.5 319.8 87.9 672.7 87.9 672.7",
  fill: "none",
  stroke: "url(#bg0_svg__dz)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dA",
  gradientUnits: "userSpaceOnUse",
  x1: 1502.257,
  y1: 717.046,
  x2: 1502.257,
  y2: 2749.017,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1600.8 1472.5c-19.3 79.1-184.4 180.9-223.7 383-35.7 183.7-151.3 306.9-66.1 551.7 65.4 188.2 96.7 258.9 37.7 429-110.2 317.9 88.9 661.6 88.9 661.6",
  fill: "none",
  stroke: "url(#bg0_svg__dA)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dB",
  gradientUnits: "userSpaceOnUse",
  x1: 1510.237,
  y1: 717.047,
  x2: 1510.237,
  y2: 2749.017,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1608.4 1473c-18.5 77.2-177.2 181.7-221.7 379.5-41.6 184.7-151.2 310.3-66.4 555.3 66.7 192.9 90.5 266.6 33.1 439.7-104.9 316.1 90 650.6 90 650.6",
  fill: "none",
  stroke: "url(#bg0_svg__dB)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dC",
  gradientUnits: "userSpaceOnUse",
  x1: 1518.274,
  y1: 717.048,
  x2: 1518.274,
  y2: 2749.018,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1616.1 1473.5c-17.8 75.2-170.1 182.5-219.8 376.1-47.5 185.6-151.2 313.8-66.6 559.2 67.9 197.4 84.2 274.2 28.3 450.2-99.7 314.2 91.1 639.6 91.1 639.6",
  fill: "none",
  stroke: "url(#bg0_svg__dC)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dD",
  gradientUnits: "userSpaceOnUse",
  x1: 1526.303,
  y1: 716.926,
  x2: 1526.303,
  y2: 2749.019,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1624 1473.9c-17.2 73.3-163.4 183.4-217.9 372.8-53.8 186.6-151.2 317.2-67 562.8 69.2 202 78.1 281.8 23.7 460.9-94.8 312.2 92.1 628.6 92.1 628.6",
  fill: "none",
  stroke: "url(#bg0_svg__dD)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dE",
  gradientUnits: "userSpaceOnUse",
  x1: 1534.163,
  y1: 717.051,
  x2: 1534.163,
  y2: 2749.021,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1631.6 1474.5c-16.4 71.4-156.6 184.2-216 369.3-60 187.4-151 320.5-67.2 566.5 70.5 206.7 71.8 289.3 19 471.4-89.7 310.2 93.2 617.6 93.2 617.6",
  fill: "none",
  stroke: "url(#bg0_svg__dE)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dF",
  gradientUnits: "userSpaceOnUse",
  x1: 1542.183,
  y1: 717.052,
  x2: 1542.183,
  y2: 2749.022,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1639.4 1475c-15.7 69.5-150.2 184.9-214 365.9-66.5 188.2-151 324-67.5 570.2 71.6 211.3 65.2 297 14.3 482.1-85 308.1 94.1 606.5 94.1 606.5",
  fill: "none",
  stroke: "url(#bg0_svg__dF)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dG",
  gradientUnits: "userSpaceOnUse",
  x1: 1550.035,
  y1: 716.931,
  x2: 1550.035,
  y2: 2749.023,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1647.3 1475.4c-15 67.5-143.8 185.7-212.2 362.6-73.2 189-151.1 327.3-67.9 573.9 72.8 215.9 58.9 304.6 9.6 492.7-80.2 306 95.2 595.5 95.2 595.5",
  fill: "none",
  stroke: "url(#bg0_svg__dG)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dH",
  gradientUnits: "userSpaceOnUse",
  x1: 1557.738,
  y1: 717.179,
  x2: 1557.738,
  y2: 2749.024,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1654.9 1476.2c-14.2 65.6-137.6 186.3-210.3 359.1-79.9 189.8-150.9 330.6-68.1 577.5 74 220.6 52.3 312.1 4.9 503.3-75.3 303.8 96.3 584.4 96.3 584.4",
  fill: "none",
  stroke: "url(#bg0_svg__dH)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dI",
  gradientUnits: "userSpaceOnUse",
  x1: 1565.484,
  y1: 717.058,
  x2: 1565.484,
  y2: 2749.026,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1662.6 1476.6c-13.5 63.8-131.4 187-208.3 355.8-86.7 190.4-150.9 334.1-68.3 581.2 75.3 225.2 45.9 319.6.2 513.9-70.9 301.8 97.3 573.3 97.3 573.3",
  fill: "none",
  stroke: "url(#bg0_svg__dI)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dJ",
  gradientUnits: "userSpaceOnUse",
  x1: 1573.162,
  y1: 717.182,
  x2: 1573.162,
  y2: 2749.028,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1670.5 1477.2c-12.8 61.8-125.4 187.5-206.5 352.3-93.9 191-151 337.4-68.7 584.9 76.5 229.9 39.3 327.1-4.4 524.5-66.3 299.6 98.4 562.3 98.4 562.3",
  fill: "none",
  stroke: "url(#bg0_svg__dJ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dK",
  gradientUnits: "userSpaceOnUse",
  x1: 1580.781,
  y1: 717.184,
  x2: 1580.781,
  y2: 2749.03,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1678.2 1477.7c-12.1 59.8-119.5 187.9-204.5 348.9-101 191.3-151 340.9-69 588.6 77.6 234.5 32.5 334.7-9.2 535.1-62 297.5 99.4 551.3 99.4 551.3",
  fill: "none",
  stroke: "url(#bg0_svg__dK)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dL",
  gradientUnits: "userSpaceOnUse",
  x1: 1588.245,
  y1: 716.941,
  x2: 1588.245,
  y2: 2749.032,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1685.8 1478c-11.4 58-113.7 188.3-202.6 345.6-108.3 191.7-150.9 344.3-69.2 592.4 78.8 239.1 25.9 342.2-13.9 545.8-57.5 295.4 100.5 540.3 100.5 540.3",
  fill: "none",
  stroke: "url(#bg0_svg__dL)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dM",
  gradientUnits: "userSpaceOnUse",
  x1: 1595.875,
  y1: 717.065,
  x2: 1595.875,
  y2: 2749.035,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1693.8 1478.6c-10.7 56-108 188.5-200.8 342.1-115.9 192-151 347.8-69.6 596.1 80 243.8 19 349.7-18.6 556.3-53.2 293.2 101.6 529.3 101.6 529.3",
  fill: "none",
  stroke: "url(#bg0_svg__dM)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dN",
  gradientUnits: "userSpaceOnUse",
  x1: 1603.299,
  y1: 717.069,
  x2: 1603.299,
  y2: 2749.037,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1701.5 1479.1c-9.9 54.1-102.3 188.5-198.8 338.7-123.5 192-150.9 351.1-69.8 599.7 81.1 248.5 12.1 357.2-23.3 567-49.1 291.2 102.6 518.2 102.6 518.2",
  fill: "none",
  stroke: "url(#bg0_svg__dN)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dO",
  gradientUnits: "userSpaceOnUse",
  x1: 1610.563,
  y1: 717.072,
  x2: 1610.563,
  y2: 2749.04,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1709.1 1479.6c-9.1 52.3-96.6 188.7-196.9 335.3-131.1 191.8-150.9 354.5-70.1 603.4 82.2 253 5 364.6-28 577.5-44.9 289 103.7 507.2 103.7 507.2",
  fill: "none",
  stroke: "url(#bg0_svg__dO)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dP",
  gradientUnits: "userSpaceOnUse",
  x1: 1618.022,
  y1: 717.074,
  x2: 1618.022,
  y2: 2749.043,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1717.1 1480.2c-8.5 50.3-91.1 188.6-195 331.9-139 191.5-151 357.9-70.4 607.1 83.4 257.8-1.9 372.2-32.7 588.1-40.9 286.9 104.6 496.2 104.6 496.2",
  fill: "none",
  stroke: "url(#bg0_svg__dP)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dQ",
  gradientUnits: "userSpaceOnUse",
  x1: 1625.077,
  y1: 717.077,
  x2: 1625.077,
  y2: 2749.047,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1724.7 1480.7c-7.8 48.3-85.4 188.4-193.1 328.5-146.9 191.1-151.5 361.4-70.7 610.8 84.1 262.7-8.9 379.7-37.3 598.8-36.9 284.8 105.7 485.2 105.7 485.2",
  fill: "none",
  stroke: "url(#bg0_svg__dQ)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dR",
  gradientUnits: "userSpaceOnUse",
  x1: 1632.446,
  y1: 717.081,
  x2: 1632.446,
  y2: 2749.05,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1732.6 1481.2c-7 46.5-79.9 188.2-191.1 325.1-154.8 190.5-151.4 364.7-70.9 614.4 85.3 267.2-16.2 387.1-42.1 609.3-33 282.7 106.7 474.1 106.7 474.1",
  fill: "none",
  stroke: "url(#bg0_svg__dR)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dS",
  gradientUnits: "userSpaceOnUse",
  x1: 1639.498,
  y1: 717.084,
  x2: 1639.498,
  y2: 2749.054,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1740.3 1481.7c-6.4 44.6-74.3 187.8-189.3 321.7-163 189.7-151.5 368.2-71.3 618.1 86.5 271.8-23.3 394.7-46.8 620-29.1 280.7 107.8 463.1 107.8 463.1",
  fill: "none",
  stroke: "url(#bg0_svg__dS)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dT",
  gradientUnits: "userSpaceOnUse",
  x1: 1646.663,
  y1: 716.965,
  x2: 1646.663,
  y2: 2749.059,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1748 1482.1c-5.7 42.6-68.7 187.3-187.3 318.4-171.1 188.9-151.3 371.6-71.5 621.9 87.7 276.4-30.7 402.1-51.5 630.5-25.2 278.7 108.9 452.1 108.9 452.1",
  fill: "none",
  stroke: "url(#bg0_svg__dT)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dU",
  gradientUnits: "userSpaceOnUse",
  x1: 1653.777,
  y1: 717.094,
  x2: 1653.777,
  y2: 2749.064,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1755.8 1482.7c-4.8 40.7-63 186.7-185.4 314.9-179.2 187.8-151.3 375-71.8 625.6 89 281.1-38.1 409.7-56.2 641.2-21.5 276.6 109.9 441 109.9 441",
  fill: "none",
  stroke: "url(#bg0_svg__dU)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg0_svg__dV",
  gradientUnits: "userSpaceOnUse",
  x1: 1661,
  y1: 717.221,
  x2: 1661,
  y2: 2749.069,
  gradientTransform: "rotate(3.793 -9790.712 543.287) scale(.99999)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.061,
  stopColor: "#b62457"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#f68943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b62457"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1763.7 1483.4c-4.2 38.8-57.4 186-183.6 311.5-187.5 186.5-151.3 378.4-72.1 629.3 90 285.6-45.6 417.2-60.9 651.7-17.8 274.6 111 429.9 111 429.9",
  fill: "none",
  stroke: "url(#bg0_svg__dV)",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
})));

const SvgBg0 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1447 2715.3"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

export default SvgBg0;